// utilities
(function (window) {
    window.cdApp = window.cdApp || {};
    var app = window.cdApp;

    app.getHashValue = function(key) {
        if (typeof key !== 'string') {
            key = '';
        } else {
            key = key.toLowerCase();
        }
        
        var keyAndHash = location.hash.toLowerCase().match(new RegExp(key + '=([^&]*)'));
        var value = '';
        
        if (keyAndHash) {
            value = keyAndHash[1];
        }
        
        return value;
    };
    app.getHashValueKeepCase = function(key) {
        if (typeof key !== 'string') {
            key = '';
        } 
        
        var keyAndHash = location.hash.match(new RegExp(key + '=([^&]*)'));
        var value = '';
        
        if (keyAndHash) {
            value = keyAndHash[1];
        }
        
        return value;
    };

    app.convertSecondsToTime = function(seconds) {
        const monthInSeconds = 30.44 * 24 * 60 * 60;
        const yearInSeconds = 365.24 * 24 * 60 * 60;
    
        const years = Math.floor(seconds / yearInSeconds);
        seconds -= years * yearInSeconds;
    
        const months = Math.floor(seconds / monthInSeconds);
        seconds -= months * monthInSeconds;
    
        const days = Math.floor(seconds / (24 * 60 * 60));
        seconds -= days * 24 * 60 * 60;
    
        const hours = Math.floor(seconds / (60 * 60));
        seconds -= hours * 60 * 60;
    
        const minutes = Math.floor(seconds / 60);
        seconds -= minutes * 60;
    
        return {
            years,
            months,
            days,
            hours,
            minutes,
            seconds
        };
    }              
    

}(window));




(function (window) {
    // dependency: CF object, make sure customerfield script already loaded

    if (!window.CF) {
        console.log('DEBUG: Error, CF is not found');
        return false;
    }

    window.cdApp = window.cdApp || {};
    var app = window.cdApp;

    // customer data
    var cusDataMap = {
        'first_name': {
            label: 'First Name', // this is label for displaying result
            cart: 'patientFirstName',
            quizStep: 'Step 12'
        },
        'last_name': {
            label: 'Last Name',
            cart: 'patientLastName',
            quizStep: 'Step 12'
        },
        'email': {
            label: 'Email Address',
            cart: 'patientEmail',
            ac: 'Patient Email',
            quizStep: 'Step 12'
        },
        // DOB
        'file_photo1': {
            label: 'Photo 1',
            cart: 'photo1',
            type: 'file',
            ac: 'Submitted Photo 1',
            quizStep: ''
        },
        'file_photo2': {
            label: 'Photo 2',
            cart: 'photo2',
            type: 'file',
            ac: 'Submitted Photo 2',
            quizStep: ''
        },
        'file_photo3': {
            label: 'Photo 3',
            cart: 'photo3',
            type: 'file',
            ac: 'Submitted Photo 3',
            quizStep: ''
        },
        // 'skin_type': {   this question has replaced to list_skin_type which is multiple checkboxes
        //     label: 'Skin Type',
        //     /*cart: '[CHECKBOXES]'*/
        //     cart: 'skinType',
        //     ac: 'Skin Type',
        //     quizStep: 'Step 1',
        //     recommendation: true // included in matrix calculation
        // },
        'list_skin_type': {
            label: 'Skin Types',
            /*cart: '[CHECKBOXES]'*/
            cart: 'skinType',
            ac: 'Skin Type',
            quizStep: 'Step 1',
            type: 'list',
            recommendation: true // included in matrix calculation
        },
        'skin_type_details': {
            label: 'Skin Type Additional Details',
            cart: 'skinTypeOther',
            ac: 'Skin Type Other',
            quizStep: 'Step 1'
        },
        // 'list_allergic_ingredients': {   // this question has removed
        //     label: 'Allergic Ingredients',
        //     cart: 'allergiesOther',
        //     type: 'list', // indicated list datatype in customerfields data column, eg: for multiple checkboxes
        //     ac: 'Allergy Details',
        //     quizStep: 'Step 2',
        //     recommendation: true
        // },
        'allergic_reactions': {
            label: 'Allergic reactions to skin products',
            cart: 'allergicReactions',
            ac: 'Allergic Reactions to Skin Products',
            quizStep: 'Step 2',
        },
        'allergic_reactions_details': {
            label: 'Allergic reactions to skin products details',
            cart: 'allergicReactionsDetails',
            ac: 'Allergic Reactions to Skin Products Details',
            quizStep: 'Step 2'
        },
        'list_main_skin_concerns': {
            label: 'Main Skin Concerns',
            /*cart: '[CHECKBOXES]'*/
            cart: 'mainSkinConcern',
            ac: 'Skin Help',
            quizStep: 'Step 3',
            type: 'list',
            recommendation: true
        },
        'main_skin_concerns_details': {
            label: 'Main Skin Concerns Additional Details',
            cart: 'skinHelpOther',
            ac: 'Skin Help Other',
            quizStep: 'Step 3'
        },
        'weekly_breakouts': {
            label: 'Weekly Breakouts',
            cart: 'AcneSeveritySelect',
            ac: 'Acne Frequency',
            quizStep: 'Step 3.1'
            // recommendation: true
        },
        'list_breakouts_location': {
            label: 'Breakouts Location',
            cart: 'AcneLocationSelect',
            ac: 'Pimple Concentrations',
            quizStep: 'Step 3.2',
            type: 'list'
            // recommendation: true
        },
        // 'list_breakouts_appearance': {           // This question has been removed
        //     label: 'Breakouts Appearance',
        //     cart: 'breakoutsAppearance',
        //     ac: 'Breakouts Appearance',
        //     quizStep: 'Step 3.3',
        //     type: 'list'
        // },
        'primary_skin_concern': {
            label: 'Primary Skin Concern',
            cart: 'primaryConcernOther',
            ac: 'Primary Concern',
            quizStep: 'Step 4',
            recommendation: true
        },
        'list_active_reactions': {
            label: 'Active Skincare Reactions',
            /*cart: '[CHECKBOXES]'*/
            cart: 'activeReactions',
            ac: 'Skin Reactions',
            quizStep: 'Step 5',
            type: 'list'
            // recommendation: true
        },
        'list_eye_area_main_concern': {
            label: 'Eye Area Main Concerns',
            /*cart: '[CHECKBOXES]'*/ 
            cart: 'eyeAreaMainConcerns',
            ac: 'Eye Area Main Concerns',
            quizStep: 'Step 6',        
            type: 'list',
            recommendation: true
        },
        'eye_area_primary_concerns': {
            label: 'Eye Area Primary Concerns',
            cart: 'eyeAreaPrimaryConcerns',
            ac: 'Eye Area Primary Concerns',
            quizStep: 'Step 7',
            recommendation: true
        },
        'birthday_month': {
            quizStep: 'Step 8'
        },
        'birthday_year': {
            quizStep: 'Step 8'
        },
        'sex': {
            label: 'Gender',
            cart: 'Sex',
            ac: 'Gender',
            quizStep: 'Step 9'
            // recommendation: true
        },
        'pregnant': {
            label: 'Pregnant',
            cart: 'pregnant',
            ac: 'Currently Pregnant',
            quizStep: 'Step 10',
            recommendation: true
        },
        'conceive': {
            label: 'Conceive',
            cart: 'conceive',
            // ac: 'Planning to Conceive',   // ClueEdit: telehealth 1.78 is removing conceive in Retail MQ. excluded from cart attribute
            quizStep: 'Step 10',
            recommendation: true
        },
        'pregnancy_safe': {
            label: 'Pregnancy Safe Recommendation',
            // cart: 'pregnancySafe',   // not in cart quistionnaire
            quizStep: 'Step 10',
            recommendation: true
        },
        'breastfeeding': {
            label: 'Breastfeeding',
            cart: 'breastfeeding',
            ac: 'Currently Breastfeeding',
            quizStep: 'Step 10'
            // recommendation: true
        },
        'anf_three_months': {
            label: 'Acne Night Formula Three Months',
            // cart: 'AcneNightFormulaThreeMonths', // not in cart questionnaire
            ac: 'Used Acne Night Formula In Last 3 Months',
            quizStep: 'Step 11'
            // recommendation: true
        },
        'cellular_three_months': {
            label: 'Cellular Three Months',
            cart: 'cellularThreeMonths',
            ac: 'Used Cellulair Repair In Last 3 Months',
            quizStep: 'Step 11'
            // recommendation: true
        },
        'hydroquinone_three_months': {
            label: 'Hydroquinone Three Months',
            cart: 'hydroquinoneThreeMonths',
            ac: 'Used Hydroquinone In Last 3 Months',
            quizStep: 'Step 11'
            // recommendation: true
        },
        'birthday_day': {},
        'reference': {
            label: 'How did you hear about us?',
            cart: 'How did you hear about us?',
            ac: 'Referral Type',
            quizStep: ''
        },
        'reference_other': {
            label: 'Reference Other',
            cart: 'referralOther',
            ac: 'Referral Source',
            quizStep: ''
        },
        'returning': {
            label: 'Are you a returning customer?',
            cart: 'returning',
            ac: 'Returning Order',
            quizStep: ''
        },
        'allergies': {
            label: 'Do you have any allergies or skin sensitivities?',
            cart: 'allergies',
            ac: 'Has Allergies',
            quizStep: ''
        },
        'medications': {
            label: 'Are you currently on any medications?',
            cart: 'medications',
            ac: 'Currently on Medication',
            quizStep: ''
        },
        'medications_other': {
            label: 'Medications Details',
            cart: 'medicationsOther',
            ac: 'Medication Details',
            quizStep: ''
        },
        'medical_conditions': {
            label: 'Do you have any pre-existing medical conditions?',
            cart: 'medicalConditions',
            ac: 'Medical Conditions',
            quizStep: ''
        },
        'medical_conditions_other': {
            label: 'Medical Conditions Details',
            cart: 'medicalConditionsOther',
            ac: 'Medical Conditions Details',
            quizStep: ''
        },
        // ClueEdit, Telehealth 1.78 - DEPRECATED
        // 'smoke': {
        //     label: 'Do you smoke?',
        //     cart: 'smoke',
        //     ac: 'Smoker',
        //     quizStep: ''
        // },
        'active_reactions_details': {
            label: 'Active Skincare Reactions Details',
            cart: 'reactionOther',
            ac: 'Skin Reactions Other',
            quizStep: ''
        },
        'eye_area_concerns_details': {
            label: 'Eye Area Main Concerns Details',
            cart: 'eyeOther',
            ac: 'Eye Area Concerns Additional Details',
            quizStep: ''
        },
        'spf': {
            label: 'Do you wear SPF daily?',
            cart: 'SPF',
            ac: 'Daily SPF',
            quizStep: ''
        },
        'fitzpatrick_type': {
            label: 'Fitzpatrick scale',
            cart: 'fitzpatrickType',
            ac: 'Fitzpatrick Type',
            quizStep: ''
        },
        'check_spf_confirm': {
            label: 'SPF Confirm',
            cart: 'spfConfirm',
            ac: 'SPF Acknowledgment',
            quizStep: ''
        },
        'procedures': {
            label: 'Planning procedures',
            /* cart: '[CHECKBOXES]' */
            cart: 'procedures',
            ac: 'Skin Procedures Recent',
            quizStep: '',
            type: 'list'
        },
        'procedures_details': {
            label: 'Planning procedures Details',
            cart: 'proceduresOther',
            ac: 'Skin Procedures Recent Other',
            quizStep: ''
        },
        'check_procedures_disclose': {
            label: 'Planning procedures Disclose',
            cart: 'discloseConfirm',
            ac: 'Disclose any of The Secret Skincare products I am using and cease use of Vitamin A',
            quizStep: ''
        },
        'product_cleanser': {
            label: 'product Cleanser',
            cart: 'productCleanser',
            ac: 'Current Cleanser',
            quizStep: ''
        },
        'product_toner': {
            label: 'product Toner',
            cart: 'productToner',
            ac: 'Current Toner',
            quizStep: ''
        },
        'product_exfoliator': {
            label: 'product Exfoliator',
            cart: 'productExfoliator',
            ac: 'Current Exfoliator',
            quizStep: ''
        },
        'product_moisturiser': {
            label: 'product Moisturiser',
            cart: 'productMoisturiser',
            ac: 'Current Moisturiser',
            quizStep: ''
        },
        'product_mask': {
            label: 'product Mask',
            cart: 'productMask',
            ac: 'Current Mask',
            quizStep: ''
        },
        'product_serum': {
            label: 'product Serum',
            cart: 'productSerum',
            ac: 'Current Serum',
            quizStep: ''
        },
        'product_oil': {
            label: 'product Oil',
            cart: 'productOil',
            ac: 'Current Oil',
            quizStep: ''
        },
        'product_eye_treatment': {
            label: 'product Eye Treatment',
            cart: 'productEyeTreatment',
            ac: 'Current Eye Treatment',
            quizStep: ''
        },
        'product_sunscreen': {
            label: 'product Sunscreen',
            cart: 'productSunscreen',
            ac: 'Current Sunscreen',
            quizStep: ''
        },
        'product_other': {
            label: 'product Other',
            cart: 'productOther',
            ac: 'Current Other Regime',
            quizStep: ''
        },
        'check_skin_regime_disclose': {
            label: 'Skincare Regime Disclose',
            cart: 'discloseSkincareRegime',
            ac: 'Skincare Regime Disclose',
            quizStep: ''
        },
        'hydroquinone': {
            label: 'Used hydroquinone before?',
            cart: 'hydroquinone',
            ac: 'Used Hydroquinone Before',
            quizStep: ''
        },
        'additional_info_text': {
            label: 'Other information',
            cart: 'additionalInfoText',
            ac: 'Other Additonal Information',
            quizStep: ''
        },
        'check_results_confirm': {
            label: 'Results Confirm',
            cart: 'resultsConfirm',
            ac: 'Variable results between patients',
            quizStep: ''
        },
        'check_refund_confirm': {
            label: 'Refund Confirm',
            cart: 'refundConfirm',
            ac: 'All sales are final and not eligible for a refund',
            quizStep: ''
        },
        'check_truth_confirm': {
            label: 'Truth Confirm',
            cart: 'truthConfirm',
            ac: 'Provided the information in a truthful manner',
            quizStep: ''
        },
        'check_pharmacy_confirm': {
            label: 'Pharmacy Confirm',
            cart: 'pharmacyConfirm',
            ac: 'Pharmacy ackowledgment',
            quizStep: ''
        },
        'check_side_effects_confirm': {
            label: 'Side Effects Confirm',
            cart: 'sideEffectsConfirm',
            ac: 'Products may cause side effects',
            quizStep: ''
        },
        'check_proper_use_confirm': {
            label: 'Proper Use Confirm',
            cart: 'properUseConfirm',
            ac: 'Use only as instructed on the label',
            quizStep: ''
        },
        'hair_thinning_location': {
            label: 'Where is your hair thinning / loss?',
            cart: 'hairThinningLocation',
            ac: 'Where is your hair thinning or loss',
            quizStep: ''
        },
        'hair_thinning_location_det': {
            label: 'Hair thinning / loss Location Additional Details',
            cart: 'hairThinningLocationDetails',
            ac: 'Hair thinning or loss Location Additional Details',
            quizStep: ''
        },
        'list_hair_thinning_cause': {
            label: 'What is the cause of your hair thinning?',
            cart: 'hairThinningCause',
            type: 'list',            
            ac: 'What is the cause of your hair thinning',
            quizStep: ''
        },
        'hair_thinning_cause_detail': {
            label: 'Cause of hair thinning Additional Details',
            cart: 'hairThinningCauseDetails',
            ac: 'Cause of hair thinning Additional Details',
            quizStep: ''
        },
        'hair_thinning_duration': {
            label: 'How long have you been experiencing hair loss/thinning?',
            cart: 'hairThinningDuration',
            ac: 'How long have you been experiencing hair loss or thinning',
            quizStep: ''
        },

        // new in 1.2
        'hydroquinone_percentage': {
            label: 'The percentage of hydroquinone you were prescribed',
            cart: 'hydroquinonePercentage',
            ac: 'The percentage of hydroquinone you were prescribed',
            quizStep: 'Step 11'
        },
        'hydroquinone_duration': {
            label: 'How long you were using hydroquinone for?',
            cart: 'hydroquinoneDuration',
            ac: 'How long you were using hydroquinone for',
            quizStep: 'Step 11'
        },
        'hydroquinone_frequency': {
            label: 'The frequency you were applying hydroquinone to the skin',
            cart: 'hydroquinoneFrequency',
            ac: 'The frequency you were applying hydroquinone to the skin',
            quizStep: 'Step 11'
        },
        'rosacea_severity': {
            label: 'Rosacea Severity',
            cart: 'rosaceaSeverity',
            ac: 'Rosacea Severity',
            quizStep: 'Step 3.4'
        },
        'partner_conceive_plan': {
            label: 'Currently planning on conceiving with partner',
            cart: 'partnerConceivePlan',
            ac: 'Currently planning on conceiving with partner',
            quizStep: ''
        },
        'satisfaction': {
            label: 'Previous Treatment Satisfaction',
            cart: 'satisfaction',
            ac: 'Previous Treatment Satisfaction',
            quizStep: ''
        },
        'prev_treatment_feedback': {
            label: 'Previous Treatment Feedback',
            cart: 'prevTreatmentFeedback',
            ac: 'Previous Treatment Feedback',
            quizStep: ''
        },
        // new in 1.3
        'clinic_name': {
            label: 'Clinic Name',
            cart: 'clinicName',
            ac: 'Referring Clinic Name',
            quizStep: ''
        },
      'clinic_email': {
            label: 'Clinic Email',
            cart: 'clinicEmail',
            ac: 'Referring Clinic Email',
            quizStep: ''
        },
      'clinic_phone': {
            label: 'Clinic Phone',
            cart: 'clinicPhone',
            ac: 'Referring Clinic Phone',
            quizStep: ''
        },
        'clinic_referral_code': {
            label: 'Clinic Referral Code',
            cart: 'clinicReferralCode',
            ac: 'Referring Clinic Code',
            quizStep: ''
        },
        'clinic_notes': {
            label: 'Clinicians Notes',
            cart: 'clinicNotes',
            ac: 'Clinicians Notes',
            quizStep: ''
        },/*,
        'clinic_consultant_name': {
            label: 'Clinic Consultant Name',
            cart: 'clinicConsultantName',
            ac: 'Consultant Name',
            quizStep: ''
        }*/
        // new in 1.4 - DEPRECATED, we use clinic code as consultant name
        // consultant name
        // clinic_consultant_name
        // clinic_go_through_quiz???
        
        // new in questionaire 1.5
        // added new questionaire for UK that have new fields
        'effects_active_reactions': {
            label: 'Has the patient experienced adverse effects from active skincare before?',
            cart: 'EffectsActiveReactions',
            ac: 'Has the patient experienced adverse effects from active skincare before',
            quizStep: ''
        },
        'check_therapist_confirm': {
            label: 'My therapist has reviewed my current routine',
            cart: 'CheckTherapistConfirm',
            ac: 'My therapist has reviewed my current routine',
            quizStep: ''
        },
        'cellular_six_months': {
            label: 'Have you used The Secret Cellular Repair night cream in the last 6 months?',
            cart: 'CellularSixMonths',
            ac: 'Have you used The Secret Cellular Repair night cream in the last 6 months',
            quizStep: ''
        },
        'cellular_six_months_break': {
            label: 'Have you had a break',
            cart: 'CellularSixMonthsBreak',
            ac: 'Have you had a break on cellular repair night cream usage',
            quizStep: ''
        },
        'check_therapist_ro_confirm': {
            label: 'My therapist has spoken to me about rotational skincare',
            cart: 'CheckTherapistRoConfirm',
            ac: 'My therapist has spoken to me about rotational skincare',
            quizStep: ''
        },
        // ClueEdit: this is deprecated, we dont store this in CF, we only put it at cart attribute
        // 'consult_required': {
        //     label: 'Consult Required',
        //     cart: 'consultRequired',
        //     ac: 'Consult Required',
        //     quizStep: ''
        // },
        // // ClueEdit: legal changes - august
        // 'script_expiry_date': {
        //     label: 'Script Expiry Date',
        //     cart: 'scriptExpiryDate',
        //     ac: 'Script Expiry Date',
        //     quizStep: ''
        // },
        // // ClueEdit: end of legal changes - august
        'location_type': {
            label: 'Location Type',
            cart: 'locationType',
            ac: 'Location Type',
            quizStep: ''
        },
        'visit_clinic': {
            label: 'Do you visit a clinic for your skin?',
            cart: 'visitClinic',
            ac: 'Do you visit a clinic for your skin?',
            quizStep: ''
        },
        'visited_clinic_name': {
            label: 'Visited Clinic Name',
            cart: 'visitedClinicName',
            ac: 'Visited Clinic Name',
            quizStep: ''
        },
        // ClueEdit: night creams new flow - theme 1.67
        'ordered_night_creams': {  // currently order night creams, and previously ordered night creams
            label: 'Ordered Night Creams',
            cart: 'orderedNightCreams',
            ac: 'Ordered Night Creams',
            quizStep: ''
        },
        'experience_night_creams': {
            label: 'How was your experience with your Night Cream',
            cart: 'experienceNightCreams',
            ac: 'How was your experience with your Night Cream',
            quizStep: ''
        },
        'experience_night_creams_1': {
            label: 'How often did you use your Night Cream after the initial phase',
            cart: 'nightCreamsHowOften',
            ac: 'How often did you use your Night Cream after the initial phase',
            quizStep: ''
        },
        'experience_night_creams_2': {
            label: 'Did you experience flaking and dryness and how long',
            cart: 'nightCreamsFlakingDryness',
            ac: 'Did you experience flaking and dryness and how long',
            quizStep: ''
        },
        // ClueEdit: telehealth - theme 1.78
        'init_consultation_confirm': {  
            label: 'I understand I will need an initial phone consultation about my order',
            cart: 'initConsultationConfirm',
            ac: 'I understand I will need an initial phone consultation about my order',
            quizStep: ''
        },
        'used_prescription_before': {
            label: 'Have you used The Secret Skincare Prescription Range before?',
            cart: 'usedPrescriptionBefore',
            ac: 'Have you used The Secret Skincare Prescription Range before',
            quizStep: ''
        },
        'arrange_phone_call': {
            label: 'Would you like to arrange a phone call with a practitioner to discuss your concerns?',
            cart: 'arrangePhoneCall',
            ac: 'Would you like to arrange a phone call with a practitioner to discuss your concerns',
            quizStep: ''
        },
        'prescription_customer': {  // used as rule condition, assigned by JS, Customer tagged with 'Prescription Customer'
            label: 'Prescription Customer',
            cart: 'prescriptionCustomer',
            ac: 'Prescription Customer',
            quizStep: ''
        },
        // // ClueEdit: we dont store this in CF, we only put it at cart attribute
        // 'consult_telehealth_required': {
        //     label: 'Consult Telehealth Required',
        //     cart: 'consultTelehealthRequired',
        //     ac: 'Consult Telehealth Required',
        //     quizStep: ''
        // },
        'patient_script_upload': {
            label: 'Patient Script Upload',
            cart: 'patientScriptUpload',
            type: 'file',
            ac: 'Patient Script Upload',
            quizStep: ''
        },

        // ClueEdit: reinstante skin quiz, theme 1.107
        'spf50': {
            label: '4. Do you wear SPF50 daily?',
            cart: 'spf50',
            ac: '4. Do you wear SPF50 daily',
            quizStep: 'Step 5',
            // type: 'list',
            recommendation: true // included in matrix calculation
        },
        'prescription_strength': {
            label: 'Do you currently use prescription-strength ingredients?',
            cart: 'prescriptionStrength',
            ac: 'Do you currently use prescription-strength ingredients',
            quizStep: 'Step 8',
            recommendation: true // included in matrix calculation
        },
        'flaking_peeling': {
            label: 'Are you currently experiencing flaking/peeling?',
            cart: 'flakingPeeling',
            ac: 'Are you currently experiencing flaking or peeling',
            quizStep: 'Step 8',
            recommendation: true // included in matrix calculation
        },
        'individual_product_or_set': {
            label: 'Would you like to opt for an individual product or Set?',
            cart: 'individualProductOrSet',
            ac: 'Would you like to opt for an individual product or Set',
            quizStep: 'Step 10',
            type: 'list',
            recommendation: true // included in matrix calculation
        },
        'include_base_range': {
            label: 'Would you like to include our Base Range as additional support to your regime?',
            cart: 'includeBaseRange',
            ac: 'Would you like to include our Base Range as additional support to your regime',
            quizStep: 'Step 10',
            recommendation: true // included in matrix calculation
        },
    }

    // map step index with label
    // it much easier to jump between steps by label
    // Because i can't find a way to get this from API
    var quizStepTitle = [
        'Intro',
        'Name',
        'Skin Condition',
        'Main Skin Concerns',
        'Primary Skin Concern',
        'SPF 50',
        'Main Concerns Around the Eye',
        'Primary Concern Around the Eye',
        'Prescription-strength Ingredients',
        'Pregnancy',
        'Individual or Set',
        'Account'
    ];

    // colud required applicable updates only restricted to:
    var consultRequiredFields = [
        'pregnant',//Are you currently pregnant?
        'conceive',//Are you currently trying to conceive?
        'breastfeeding',//Are you currently breastfeeding?
        'medications',//Are you currently on any medications?
        'medications_other' // TODO: i assume we add this as well, because it related to medications        
    ];

    app.RECOMMENDATION_STATUS = {
        FOUND: 'found',
        NOTFOUND: 'not found',
        ERROR: 'error',
        NODATA: 'no data'
    };

    // // special product handle, for hair and gift
    // app.PRODUCTS_TYPE = {
    //     'the-hair-growth-foam' : {
    //         type: 'hair'
    //     },
    //     'the-secret-skincare-gift-card' : {
    //         type: 'giftcard'
    //     }
    // };

    app.nodeListToArray = function(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
          if (!filter || nodeList[i].matches(filter)) {
            items.push(nodeList[i]);
          }
        }

        return items;
      };

    function containsQueryString(field) {
        // var field = 'q';
        var url = window.location.href;
        if(url.indexOf('?' + field + '=') != -1)
            return true;
        else if(url.indexOf('&' + field + '=') != -1)
            return true;
        return false                
    }

    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     * Using Math.round() will give you a non-uniform distribution!
     */
    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }


    // cleanup all hidden fields
    function resetHiddens(el) {
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }

        // ClueUpdate, set default values
        // because on cart, when you go to checkout, then cancel & back, old variable still exists until overriden
        addHidden(el, 'Order contains prescription + Base Range products', 'No');
        addHidden(el, 'Order is Base Range ONLY', 'No');        
    }

    // add hidden fields, or use existing
    function addHidden(el, name, value) {
        var input = document.querySelector('input[name="attributes[' + name + ']"]');

        // ClueEdit: cart attribute with empty value seems to be ignored when go to checkout. so don't set empty value for null
        // // null value
        // if (typeof value === 'undefined' || value === null) {
        //     value = '';
        // }

        if (input) {
            // update value
            input.value = value;
        } else {
            var input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", 'attributes[' + name + ']');
            input.setAttribute("value", value);
            el.appendChild(input);
        }
    }

    function getFieldValueByType(type, value) {
        // file
        if (type === 'file') {
            // image object, use url property
            if (value && value.url) {
                value = value.url;
            } else {
                value = '';
            }
        } else {
            // do nothing
        }

        return value;
    }




    // this is new implementation of consult required based on telehealth requirement in august 2024, in theme 1.78
    // return value:
    // undefined = skip (clinic)
    // true = Yes
    // false = No
    function checkConsultRequiredTelehealth() {
        let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
        let clinicName = CF.customer.get('clinic_name'); //cfForm.getFieldValue('clinic_name');
        let reference = CF.customer.get('reference'); //cfForm.getFieldValue('reference');
        if (!loggedIn && clinicName && reference == 'Clinic') {
            return undefined;
        }        

        let consultRequired = false;

        let prescriptionCustomer = CF.customer.get('prescription_customer');
        let initConsultationConfirm = CF.customer.get('init_consultation_confirm');
        let usedPrescriptionBefore = CF.customer.get('used_prescription_before');
        let arrangePhoneCall = CF.customer.get('arrange_phone_call');

        console.log('DEBUG: Telehealth, prescriptionCustomer', prescriptionCustomer);
        console.log('DEBUG: Telehealth, usedPrescriptionBefore', usedPrescriptionBefore);
        console.log('DEBUG: Telehealth, arrangePhoneCall', arrangePhoneCall);
        console.log('DEBUG: Telehealth, initConsultationConfirm', initConsultationConfirm);

        // need to do consultation when:
        if (
            // non prescription customer (never bought prescription before, by checking customer's tag Prescription Customer)
            (prescriptionCustomer === 'no' && initConsultationConfirm === true) ||
            // prescription customer, never used prescription before
            (prescriptionCustomer === 'yes' && usedPrescriptionBefore === 'No' && initConsultationConfirm === true) ||
            // prescription customer, used prescription before, and want to arrange phone call
            (prescriptionCustomer === 'yes' && usedPrescriptionBefore === 'Yes' && arrangePhoneCall === 'Yes')
            ) {
            consultRequired = true;
        }

        // // non australian/overseas, no need to consult
        // let locationType = CF.customer.get('location_type');
        // if (locationType === 'Overseas') {
        //     consultRequired = false;
        // }

        return consultRequired;
    }



    app.cartForm = function () {
        // Form API
        CF.ready(function () {
            // Find the first CF form on the page.
            var $cfForm = document.querySelector('form[data-cf-form]');
            var cfForm = $cfForm.cfForm;
            console.log('DEBUG: my form is ready!!!');
            var useACField = true; // use AC field if exists, fallback to cart attributes
            var storageDoneKey = 'cd-cart-cfform-done';
            var storageQuestionnaireTypeKey = 'cd-cart-cfform-type';
            var storageCustomerIdKey = 'cd-cart-customer-id';
            var storageQuestionnaireOrderedNightCreams = 'cd-cart-cfform-orderednightcreams';
            


            // var $notDoneMessage = document.querySelector('.Cart__CheckoutQuestionaireNotDone');
            // var $doneMessage = document.querySelector('.Cart__CheckoutQuestionaireDone');

            var $formContainer = document.querySelector('.Cart__CFForm');
            var formOpenClass = 'Cart__CFForm--open';
            var bodyFormOpenClass = 'cart-cfform-open';

            function openForm() {
                console.log('DEBUG: open form');
                $formContainer.classList.add(formOpenClass);
                document.body.classList.add(bodyFormOpenClass);
            }

            function closeForm() {
                console.log('DEBUG: close form');
                $formContainer.classList.remove(formOpenClass);
                document.body.classList.remove(bodyFormOpenClass);
            }


            // get current details of products inside cart, by parsing the dom
            // note that dom can be updated via ajax, so you need to run this again when cart is updated via ajax to get fresh data
            // output = array of objects [ { handle: "the-hair-growth-foam" }, { handle: "acne-night-formula-face-body" } ]
            function getCartProducts() {
                var $cartItems = document.querySelectorAll('.CartItem');
                console.log('DEBUG: cart items ??????', $cartItems);

                var cartProducts = [];

                if (!$cartItems.length) {
                    return cartProducts;
                }
                
                var i, handle, productType, tags;
                var hasNightCream = false;
                var hasSet = false;
                for (i = 0; i !== $cartItems.length; ++i) {
                    handle = $cartItems[i].getAttribute('data-cartitem-product-handle');
                    productType = $cartItems[i].getAttribute('data-cartitem-product-type');

                    tags = JSON.parse($cartItems[i].getAttribute('data-cartitem-product-tags'));
                    if (tags && tags.indexOf('Night Creams') > -1) {
                        hasNightCream = true;
                    }
                    if (tags && tags.indexOf('Skincare Set') > -1) {
                        hasSet = true;
                    }

                    cartProducts.push({
                        'handle': handle,
                        'productType': productType,
                        'hasNightCream': hasNightCream,
                        'hasSet': hasSet
                    });
                }
                
                console.log('DEBUG: cart products', cartProducts);

                return cartProducts;
                
            }


            function getCartUserId() {
                var $cartItemList = document.querySelector('.Cart__ItemList');

                if (!$cartItemList) {
                    return '';
                }

                return $cartItemList.getAttribute('data-cart-customer-id');
            }

            // this set value of field questionnaire_type on the CFForm, depend on products in the cart
            function updateQuestionnaireType() {
                var cartProducts = getCartProducts();
                if (!cartProducts.length) {
                    return false;
                }

                var hasHair = false;
                var hasGiftCard = false;
                var hasSkin = false;
                // var giftCardCount = 0;
                var hasNonPrescription = false;
                // var nonPrescriptionCount = 0;

                cartProducts.forEach(function(cartProduct) {
                    console.log('DEBUG: cart product', cartProduct);

                    /* Detect by product handle. not used anymore.
                    var special = app.PRODUCTS_TYPE[cartProduct.handle];

                    if (special) {
                        if (special.type === 'hair') {
                            hasHair = true;
                        }
                        if (special.type === 'giftcard') {
                            hasGiftCard = true;
                        }    
                    } else {
                        // assume products other than special (hair & gifcard) are skin
                        hasSkin = true;
                    }
                    */

                    if (cartProduct.productType === 'hair') {
                        hasHair = true;
                    } else if (cartProduct.productType === 'giftcard') {
                        hasGiftCard = true;
                    } else if (cartProduct.productType === 'nonprescription') {
                        hasNonPrescription = true;
                    } else {
                        // assume products other than special (hair & gifcard) are skin
                        hasSkin = true;
                    }

                });

                // cart only contains giftcard or non prescription, skip questionnaire
                if ((hasGiftCard || hasNonPrescription) && !(hasHair || hasSkin)) {
                    console.log('DEBUG: ?????? the cart doesnt contain hari or skin products, skip questionnaire!');
                    return 'nonprescription';
                }

                if (hasHair && !hasSkin) {
                    // hair only
                    console.log('DEBUG: ?????? questionnaire type: hair only ');
                    cfForm.setFieldValue('questionnaire_type', 'hair');
                    return 'hair';
                } else if (hasHair && hasSkin) {
                    console.log('DEBUG: ?????? questionnaire type: hair and skin ');
                    cfForm.setFieldValue('questionnaire_type', 'skin and hair');
                    return 'skin and hair';
                } else {
                    console.log('DEBUG: ?????? questionnaire type: skin only ');
                    cfForm.setFieldValue('questionnaire_type', 'skin');
                    return 'skin';
                }

            }

            // this set the value of ordered_night_creams field on the CFForm, depend on customer's order history was ever ordered night creams or not
            // and whether current cart contains night creams or not
            // UPDATE: since prescribe for me v2, products have been rearranged, and sets are new. now sets are not contains Night Creams tag anymore, so need to detect sets as well. so nightcreams variable below are referring both night creams and sets
            // set always contains night creams
            function updateOrderedNightCreams() {
                var cartProducts = getCartProducts();
                var cartHasNightCream = false;
                if (!cartProducts.length) {
                    return false;
                }

                cartProducts.forEach(function(cartProduct) {
                    if (cartProduct.hasNightCream || cartProduct.hasSet) {
                        console.log('DEBUG: cart contains night creams');
                        cartHasNightCream = true;
                    }
                });


                console.log('DEBUG: customer order data', window.cdApp.customersDataOrders);
                // check if customer ever buy night cream, based on tags named "Night Creams"

                function hasBoughtNightCreams() {
                    for (var i = 0; i < window.cdApp.customersDataOrders.length; i++) {
                      var order = window.cdApp.customersDataOrders[i];
                      for (var j = 0; j < order.lineItems.length; j++) {
                        var lineItem = order.lineItems[j];
                        console.log(typeof lineItem.productTags);
                        if (lineItem.productTags && lineItem.productTags.length && (lineItem.productTags.indexOf("Night Creams") > -1 || lineItem.productTags.indexOf("Skincare Set") > -1)) {
                          return true;
                        }
                      }
                    }
                    return false;
                }
            
                var orderedNightCreams = ((hasBoughtNightCreams() && cartHasNightCream)?'yes':'no');

                console.log('Does cart contains Night Creams or sets?', cartHasNightCream);    
                console.log('Has customer ever bought Night Creams or sets?', hasBoughtNightCreams());    

                console.log('ordered Night Creams or sets?', orderedNightCreams);
                
                cfForm.setFieldValue('ordered_night_creams', orderedNightCreams);
                return orderedNightCreams;
            }

            // this set the value of prescription_customer field on the CFForm, depend on customer's tag
            function updatePrescriptionCustomer() {
                var prescriptionCustomer = 'no';

                var customerTags = CF.customer.get('tags');
                if (customerTags && customerTags.indexOf('Prescription Customer') > -1) {
                    prescriptionCustomer = 'yes';
                }
                // console.log('DEBUG: Customer', customerTags);
                console.log('DEBUG: Customer, prescriptionCustomer', prescriptionCustomer);

                cfForm.setFieldValue('prescription_customer', prescriptionCustomer);

                // return prescriptionCustomer;
            }

            function saveDone(value) {
                sessionStorage.setItem(storageDoneKey, value);
            }

            function saveQuestionnaireType(value) {
                sessionStorage.setItem(storageQuestionnaireTypeKey, value);
            }

            function getSavedQuestionnaireType() {
                return sessionStorage.getItem(storageQuestionnaireTypeKey);
            }

            function saveQuestionnaireOrderedNightCreams(value) {
                sessionStorage.setItem(storageQuestionnaireOrderedNightCreams, value);
            }

            function getSavedQuestionnaireOrderedNightCreams() {
                return sessionStorage.getItem(storageQuestionnaireOrderedNightCreams);
            }

            function saveCustomerId(value) {
                sessionStorage.setItem(storageCustomerIdKey, value);
            }

            function getSavedCustomerId() {
                return sessionStorage.getItem(storageCustomerIdKey);
            }

            function baseRangeCartAttributes() {
                console.log('DEBUG: non prescription products');
                var $cartForm = document.querySelector('form.Cart');
                var $hiddensEl = $cartForm.querySelector('.Cart__Hiddens');
                
                resetHiddens($hiddensEl);

                var $cartItems = document.querySelectorAll('.CartItem');
                if (!$cartItems.length) {
                    return false;
                }

                var hasBaseRange = false;

                var i, tags;
                for (i = 0; i !== $cartItems.length; ++i) {
                    tags = JSON.parse($cartItems[i].getAttribute('data-cartitem-product-tags'));
                    if (tags && tags.indexOf('Base Range') > -1) {
                        hasBaseRange = true;
                        break;
                    }
                }
                
                if (hasBaseRange) {
                    addHidden($hiddensEl, 'Order is Base Range ONLY', 'Yes');    
                }
                
            
            }

            function autoAddConsultationProductToCart() {
                // var value = CF.customer.get('consult_required');
                let consultTelehealthRequired = checkConsultRequiredTelehealth();
                console.log('DEBUG: Customer, auto add to cart', consultTelehealthRequired);

                let consultProductVariant = '43597787660335';//'43200698056751';
                let consultProductAdded = false;
                let consultProductCount = 0;

                let paidConsultProductVariant = '43597801062447'; // paid consultation product
                let paidConsultProductAdded = false;
                let paidConsultProductCount = 0;

                // quick way to prevent double adding (since this function is potentially run multiple times)
                // window.cdApp.consultProductAdding = false;


                var $cartItems = document.querySelectorAll('.CartItem');
                console.log('DEBUG: Customer, auto add to cart, cart items', $cartItems);

                if (!$cartItems.length) {
                    return false;
                }

                // check if product already there, to avoid duplicate adding
                var i, variantId, tags;
                let removedLine = undefined;
                let hasPrescriptionProduct = false;
                for (i = 0; i !== $cartItems.length; ++i) {
                    variantId = $cartItems[i].getAttribute('data-cartitem-product-variant-id');

                    if (variantId === consultProductVariant) {
                        consultProductAdded = true;
                        consultProductCount++;

                        removedLine = $cartItems[i].getAttribute('data-cartitem-product-line');
                    }    
                    
                    if (variantId == paidConsultProductVariant) {
                        paidConsultProductAdded = true;
                        paidConsultProductCount++;
                    }

                    tags = JSON.parse($cartItems[i].getAttribute('data-cartitem-product-tags'));
                    if (tags && tags.indexOf('Prescription') > -1) {
                        hasPrescriptionProduct = true;                        
                    }
                
                }
      
                // when consult product already there, but no prescription product, trigger delete
                if (!hasPrescriptionProduct) {
                    consultTelehealthRequired = false;
                    console.log('DEBUG: no prescription product');
                } 

                // when paid consult product already there, trigger delete
                if (paidConsultProductAdded) {
                    consultTelehealthRequired = false;
                }
                
                function submitTheForm() {
                    var $secondaryBtn = document.querySelector('#Cart__SecondaryCheckout');
                    if ($secondaryBtn) {
                        console.log('DEBUG: click secondary checkout button');
                        $secondaryBtn.click();
                    }
                }

                if (consultTelehealthRequired === true) {

                    if (!consultProductAdded && !window.cdApp.consultProductAdding) {
                        console.log('DEBUG: Customer, auto add to cart');
                        window.cdApp.consultProductAdding = true;
                        document.dispatchEvent(new CustomEvent('theme:loading:start'));
                        fetch('/cart/add.js', {
                            body: JSON.stringify({
                              items: [{
                                id: consultProductVariant,
                                quantity: 1
                              }]
                            }),
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                  
                            }
                          }).then(function (cart) {
                            console.log('DEBUG: Customer, consult product added');
                            window.cdApp.consultProductAdding = false;
                            // location.reload();

                            // Redirect to checkout
                            document.dispatchEvent(new CustomEvent('theme:loading:end'));
                            // window.location.href = '/checkout';       
                            submitTheForm();             

                          });                
                    } else {
                        console.log('DEBUG: Customer, consult product already in cart');
                        // window.location.href = '/checkout';       
                        submitTheForm();                     
                    }

                } else {
                    // window.location.href = '/checkout';           
                    submitTheForm();                 
                }
        

            }

            // show message whether form done or not
            // update: this also decide the questionnaire type, currently skin, hair, skin dan hair
            function updateDoneDisplay(forceDone) {
                forceDone = forceDone || false;
                var $done = document.querySelector('.Cart__CheckoutQuestionaireDone');
                var $notDone = document.querySelector('.Cart__CheckoutQuestionaireNotDone');

                var $messageWrapper = document.querySelector('.MedicalQuestionnaire');

                var $checkoutBtn = document.querySelector('.Cart__Checkout.Button');

                if (!$done || !$notDone) {
                    return false;
                }

                // UK Clinic Form, check

                // // just for testing
                // let testDetect = cfForm.getFieldValue('birthday_month');
                // console.log('DEBUG: testDetact', testDetect);
                // if (testDetect === '7') {
                //     if (!containsQueryString('ukclinicredirect')) {
                //         // alert('DEBUG: july!!!');
                //         // to prevent shopify cache the querystring value
                //         window.location.href = "/cart?ukclinicredirect=true&view="+getRandomInt(0,999999);
                //     }
                // }                
                // let clinicReferralCode = cfForm.getFieldValue('clinic_referral_code');
                // if (clinicReferralCode === 'PHI') {
                //     if (!containsQueryString('ukclinicredirect')) {
                //         // alert('DEBUG: july!!!');
                //         console.log('DEBUG: UK clinic redirect');
                //         // to prevent shopify cache the querystring value
                //         window.location.href = "/cart?ukclinicredirect=true&view="+getRandomInt(0,999999);
                //     }
                // }
                // ClueEdit: legal changes
                // detect if clinic by checking if customer not logged in and clinic name has value, and reference = Clinic
                // then if clinic_name=Phi,redirect to UK clinic form
                // else, redirect to AU clinic form
                let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
                let clinicName = CF.customer.get('clinic_name'); //cfForm.getFieldValue('clinic_name');
                let reference = CF.customer.get('reference'); //cfForm.getFieldValue('reference');
                if (!loggedIn && clinicName && reference == 'Clinic') {
                    if (clinicName === 'Phi') {
                        if (!containsQueryString('ukclinicredirect')) {
                            // alert('DEBUG: july!!!');
                            console.log('DEBUG: UK clinic redirect');
                            // to prevent shopify cache the querystring value
                            window.location.href = "/cart?ukclinicredirect=true&view="+getRandomInt(0,999999);
                        }
                    } else {
                        // alert('redirect AU clinic, clinic name: '+clinicName);
                        if (!containsQueryString('auclinicredirect')) {
                            // alert('DEBUG: july!!!');
                            console.log('DEBUG: AU clinic redirect');
                            // to prevent shopify cache the querystring value
                            window.location.href = "/cart?auclinicredirect=true&view="+getRandomInt(0,999999);
                        }
                    }
                }




                // check questionnaire type and update questionnaire_type field in the form
                var questionnaireType = updateQuestionnaireType();

                // if questionnaire type changed from previously saved, make sure customer need to resubmit questionnaire
                var previousQuestionnaireType = getSavedQuestionnaireType();
                // console.log('DEBUG: questionnaire type changed?', previousQuestionnaireType, questionnaireType);
                if (previousQuestionnaireType !== questionnaireType) {
                    // reset done
                    // customer need to resubmit questionnaire
                    console.log('DEBUG: questionnaire type has been changed. set done to false');
                    saveDone(false);
                }
                saveQuestionnaireType(questionnaireType);

                // check ordered night creams?
                var previousOrderedNightCreams = getSavedQuestionnaireOrderedNightCreams();
                var orderedNightCreams = updateOrderedNightCreams();

                if (previousOrderedNightCreams !== orderedNightCreams) {
                    console.log('DEBUG: ordered night creams has been changed. set done to false');
                    saveDone(false);
                    // cfForm.setFieldValue('experience_night_creams', false); // can't do this, because it also has rules that only work when form is running (hide/show parapgraph text)
                }
                saveQuestionnaireOrderedNightCreams(orderedNightCreams);

                // also check if user changes?
                var prevCartCustomerId = getSavedCustomerId();
                var cartCustomerId = getCartUserId();
                if (/*cartCustomerId &&*/ (cartCustomerId !== prevCartCustomerId)) {
                    console.log('DEBUG: customer id has been changed. set done to false');
                    saveDone(false)
                }
                saveCustomerId(cartCustomerId);

                // getCartProducts();

                // check prescription customer. since it should never change (based on customer tag), no need to check if it changed
                updatePrescriptionCustomer();

                // show/hide checkout button and message
                var done = sessionStorage.getItem(storageDoneKey);
                done = JSON.parse(done); // session storage value is string. need to convert to boolean

                if (done || forceDone) {
                    // rebuild hidden fields
                    rebuildCartAttributes();

                    $done.style.display = 'block';
                    $notDone.style.display = 'none';
                    $checkoutBtn.removeAttribute('disabled');
                    $messageWrapper.style.display = 'block';

                    // Consultation Notice
                    let $consultNotice = document.querySelector('.MedicalQuestionnaireConsultNotice');
                    if ($consultNotice) {
                        let consultTelehealthRequired = checkConsultRequiredTelehealth();
                        // $consultNotice.style.backgroundColor = 'fuchsia';
                        if (consultTelehealthRequired) {
                            $consultNotice.style.display = 'block';
                        } else {
                            $consultNotice.style.display = 'none';
                        }
        
                    } 

                } else {
                    $done.style.display = 'none';
                    $notDone.style.display = 'block';
                    $checkoutBtn.setAttribute('disabled','disabled');
                    $messageWrapper.style.display = 'block';
                }
                
                // if nonprescription (giftcard & nonprescription & base range), no need to submit questionnaire
                if (questionnaireType === 'nonprescription') {
                    $done.style.display = 'none';
                    $notDone.style.display = 'none';
                    $checkoutBtn.removeAttribute('disabled');
                    $messageWrapper.style.display = 'none';

                    // add base range only cartattributes
                    // when cart only contains base range (and optionally other non-prescription products only)
                    baseRangeCartAttributes();
                }

                if (forceDone) {
                    saveDone(true);
                }

                // ClueEdit: Telehealth - marked as deprecated
                // // ClueEdit: legal changes - August
                // // consult required message
                // var $consultMessage = document.querySelector('.MedicalQuestionnaireConsultMessage');
                // let consultRequired = checkConsultRequired();

                // if (typeof consultRequired === 'undefined') {
                //     console.log('DEBUG: clinic doesnt need consult required check message');
                // } else {
                //     if ($consultMessage) {
                //         if (consultRequired) {
                //             $consultMessage.style.display = 'block';
                //         } else {
                //             $consultMessage.style.display = 'none';
                //         }    
                //     }        
                // }
                // // ClueEdit: end of legal changes - August

                // autoAddConsultationProductToCart();



            }

            updateDoneDisplay();
            window.cdApp.updateDoneDisplay = updateDoneDisplay;

            // cart section is updated via ajax, so we can't queryselector it
            var delegatePage = new domDelegate.Delegate(document.getElementById('main'));
            delegatePage.on('click', '.Cart__OpenCFForm', function(ev) {
                console.log('DEBUG: Cart__OpenCFForm clicked', ev.target);
                if ($formContainer.classList.contains(formOpenClass)) {
                    closeForm();
                } else {
                    cfForm.goToStep(0);

                    (function(){
                        // ClueEdit: reset some values when its not considered done
                        var done = sessionStorage.getItem(storageDoneKey);
                        // session storage value is string. need to convert to boolean
                        try {
                            done = JSON.parse(done);
                        } catch (e) {
                            done = false;
                        }                

                        if (!done) {
                            console.log('DEBUG: not done, reset some values');

                            // reset experience_night_creams value
                                console.log('DEBUG: reset the experience_night_creams');
                                cfForm.setFieldValue('experience_night_creams', undefined);
                                cfForm.setFieldValue('experience_night_creams_1', undefined);
                                cfForm.setFieldValue('experience_night_creams_2', undefined);

                            // reset init_consultation_confirm, used_prescription_before, arrange_phone_call
                                console.log('DEBUG: reset the init_consultation_confirm, used_prescription_before, arrange_phone_call');
                                cfForm.setFieldValue('init_consultation_confirm', undefined);
                                cfForm.setFieldValue('used_prescription_before', undefined);
                                cfForm.setFieldValue('arrange_phone_call', undefined);

                                cfForm.setFieldValue('no_consultation_confirm', undefined);
                                cfForm.setFieldValue('used_customformula_confirm', undefined);

                                // medications and medications_others
                                cfForm.setFieldValue('medications', undefined);
                                cfForm.setFieldValue('medications_other', undefined);

                            // reset photos values
                                console.log('DEBUG: reset photos');
                                cfForm.setFieldValue('file_photo1', undefined);
                                cfForm.setFieldValue('file_photo2', undefined);
                                cfForm.setFieldValue('file_photo3', undefined);

                        }

                    }());

                    openForm();
                }
            } );
            delegatePage.on('click', '.Cart__CFFormClose', function(ev) {
                closeForm();
            } );
            

            // checkout click
            // set done to false, so next shopping will require to fill questionnaire again
            // this is fine because clicking checkout is the only way to go to checkout page?
            delegatePage.on('click', '.Cart__Checkout', function(ev) {
                console.log('DEBUG: checkout!');
                saveDone(false);

                // ClueEdit: Telehealth

                // Prevent the default action
                ev.preventDefault();
                // cartToCheckout(43200698056751, 1);
                autoAddConsultationProductToCart();
            });


            function rebuildCartAttributes() {
                // var skinType = cfForm.getFieldValue('skin_type');
                // console.log('DEBUG:skinType = ', skinType);

                // // here we set the cart attributes form
                // document.querySelector('textarea[name="attributes[skin_type]"]').value = 'filled skinType = ' + skinType;

                var $cartForm = document.querySelector('form.Cart');
                var $hiddensEl = $cartForm.querySelector('.Cart__Hiddens');

                resetHiddens($hiddensEl);

                // hiddens data
                // array of object like [ { field:'primary_skin_concern', name:'Primary Concern', value:'' } ]
                var hiddensData = [];


                // create hidden fields
                var field, type, value;
                for (field in cusDataMap) {
                    // console.log('DEBUG: field', field);
                    if (cusDataMap.hasOwnProperty(field)) {
                        // console.log('DEBUG: field value ', cusDataMap[field]);
                        type = cusDataMap[field].type || 'text';
                        // value = cfForm.getFieldValue(field);
                        // ClueEdit: Legal Changes, this is more realtime, because after saving form we still saving data to CF?
                        value = CF.customer.get(field);
                        
                        value = getFieldValueByType(type, value);


                        // // for list, use CSV, no need to do this... shopify & AC backend convert array to csv
                        // if (type === 'list' && (typeof value === 'array' || typeof value === 'object') && value.length) {
                        //     console.log('DEUG: 🎉🎉🎉', field, type, value);
                        //     let valueArray = [];
                        //     value.forEach(function(listValue) {
                        //         valueArray.push(listValue);
                        //     });
                        //     value = valueArray.join();
                        // }

                        // filter pregnancy related
                        // ClueEdit: telehealth 1.78 is removing conceive in Retail MQ. code below should has no conflict
                        if (['pregnant', 'conceive', 'pregnancy_safe', 'breastfeeding'].indexOf(field) > -1) {
                            let sex = cfForm.getFieldValue('sex');
                            if (sex === 'Male' || sex === 'Transwoman (MTF)') {
                                console.log('DEBUG: exclude pregnany related values');
                                continue;
                            }
                        }
                        // filter acne related
                        if (['weekly_breakouts','list_breakouts_location'].indexOf(field) > -1) {
                            let mainSkinConcern = cfForm.getFieldValue('list_main_skin_concerns');

                            if ((typeof mainSkinConcern === 'array' || typeof mainSkinConcern === 'object') && mainSkinConcern.length && mainSkinConcern.indexOf('Acne and/or breakouts') < 0) {
                                console.log('DEBUG: exclude acne related values');
                                continue;
                            }
                        }

                        // filter rosacea severity related
                        if (['rosacea_severity'].indexOf(field) > -1) {
                            let mainSkinConcern = cfForm.getFieldValue('list_main_skin_concerns');

                            if ((typeof mainSkinConcern === 'array' || typeof mainSkinConcern === 'object') && mainSkinConcern.length && mainSkinConcern.indexOf('Rosacea') < 0) {
                                console.log('DEBUG: exclude rosacea related values');
                                continue;
                            }
                        }

                        // filter partner_conceive_plan
                        // it only for male and hair product
                        if (['partner_conceive_plan'].indexOf(field) > -1) {
                            let sex = cfForm.getFieldValue('sex');
                            let questionnaireType = cfForm.getFieldValue('questionnaire_type');

                            if (!(sex === 'Male' && (questionnaireType.indexOf('hair') >= 0))) {
                                console.log('DEBUG: exclude partner_conceive_plan related values');
                                continue;
                            }
                        }

                        // filter previous treatment related
                        // it only for returning customer
                        if (['satisfaction', 'prev_treatment_feedback'].indexOf(field) > -1) {
                            let returning = cfForm.getFieldValue('returning');
                            if (returning !== 'Yes') {
                                console.log('DEBUG: exclude previous treatment related values');
                                continue;
                            }
                        }

                        // ClueEdit: hydroquinone related question has been deleted from MQ, since it doesn't looks breaking, will keep it for old customer data
                        // filter hydroquinone related
                        // it only whcn used hydroquinone for 3 months
                        if (['hydroquinone_percentage','hydroquinone_duration','hydroquinone_frequency'].indexOf(field) > -1) {
                            let hydroquinoneThreeMonths = cfForm.getFieldValue('hydroquinone_three_months');
                            if (hydroquinoneThreeMonths !== 'Yes') {
                                console.log('DEBUG: exclude hydroquinone related values');
                                continue;
                            }
                        }

                        // make undefined empty
                        value = (typeof value === 'undefined')?'':value;


                        if (useACField && cusDataMap[field].ac) {
                            // addHidden($hiddensEl, cusDataMap[field].ac, value);
                            hiddensData.push({
                                'field': field,
                                'name': cusDataMap[field].ac,
                                'value': value
                            });
                        } else {
                            // use cart
                            if (cusDataMap[field].cart) {
                                // addHidden($hiddensEl, cusDataMap[field].cart, value);
                                hiddensData.push({
                                    'field': field,
                                    'name': cusDataMap[field].cart,
                                    'value': value
                                });
    
                            }
                        }
                    }
                }

                // add hiddens of form fields
                console.log('DEBUG: hiddensData', hiddensData);
                if (hiddensData.length) {
                    hiddensData.forEach(function(hiddenData) {
                        addHidden($hiddensEl, hiddenData.name, hiddenData.value);
                    });
                }

                // DOB
                var mergedDOB = cfForm.getFieldValue('birthday_day') + '-' + cfForm.getFieldValue('birthday_month') + '-' + cfForm.getFieldValue('birthday_year');
                // TODO: patient name merged
                var mergedName = cfForm.getFieldValue('first_name') + ' ' + cfForm.getFieldValue('last_name');

                if (useACField) {
                    addHidden($hiddensEl, 'Patient Date of Birth', mergedDOB);
                    addHidden($hiddensEl, 'Patient Name', mergedName);

                    // how did you hear, is similar to referral type
                    addHidden($hiddensEl, 'How Did You Hear?', cfForm.getFieldValue('reference'));
                } else {
                    addHidden($hiddensEl, 'Patient Date of Birth', mergedDOB);
                }




                // addHidden($hiddensEl, "patientLastName", cfForm.getFieldValue('last_name'));

                // base range
                var $cartItems = document.querySelectorAll('.CartItem');
                var hasBaseRange = false;
                var hasPaidMedicalConsult = false;
            
                if ($cartItems.length) {
                    let i, tags, handle;
                    for (i = 0; i !== $cartItems.length; ++i) {
                        tags = JSON.parse($cartItems[i].getAttribute('data-cartitem-product-tags'));
                        handle = $cartItems[i].getAttribute('data-cartitem-product-handle');

                        if (tags && tags.indexOf('Base Range') > -1) {
                            hasBaseRange = true;
                            // break;
                        }

                        if (handle === 'medical-phone-consult') {
                            hasPaidMedicalConsult = true;
                        }
                    }
            
                    if (hasBaseRange) {
                        addHidden($hiddensEl, 'Order contains prescription + Base Range products', 'Yes');
                    }
                }
              

                // ClueEdit: Telehealth - marked as deprecated
                // ClueEdit: legal changes - August
                // let consultRequired = checkConsultRequired();

                // if (typeof consultRequired === 'undefined') {
                //     console.log('DEBUG: clinic doesnt need consult required cart attribute');
                // } else {
                //     addHidden($hiddensEl, 'Consult Required', (consultRequired?'Yes':'No'));
                // }
                // ClueEdit: end of legal changes - August

                // ClueEdit: Telehealth update August 2024
                let consultTelehealthRequired = checkConsultRequiredTelehealth();
                console.log('DEBUG: Customer, consultTelehealthRequired', consultTelehealthRequired);
                if (typeof consultTelehealthRequired === 'undefined') {
                    console.log('DEBUG: clinic doesnt need consult telehealth required cart attribute');
                } else {
                    if (!hasPaidMedicalConsult) {
                        addHidden($hiddensEl, 'Consult Telehealth Required', (consultTelehealthRequired?'Yes':'No'));
                    }
                }

                // ClueEdit: new skinquiz - 1.107
                // when the cart contains Paid Medical Consult (medical-phone-consult)
                if (hasPaidMedicalConsult) {
                    addHidden($hiddensEl, 'Consult Telehealth Required', 'Yes');
                }
            }


            cfForm.beforeSave(() => {
                console.log('DEBUG: before saved!!!');

                rebuildCartAttributes();

                // and we unlock the checkout button
                var $checkoutBtn = document.querySelector('.Cart__Checkout.Button');
                console.log('DEBUG: unlock checkout button', $checkoutBtn);
                $checkoutBtn.removeAttribute('disabled');

                // // TEST IMAGE
                // console.log(cfForm.getFieldValue('file_photo1'));
            });


            
            // submitted successfully
            $cfForm.addEventListener('cf:form_submitted', function(event) {
                var formId = event.detail.formId;
                var submissionData = event.detail.submissionData;

                // ClueEdit: legal changes
                console.log('DEBUG: medical questionaire - check expiration script');

                // ClueEdit: clinic quick fix - possible cause: for some reason, after submit, the form change url to current url with addition &cfShowSuccessStep=true, eg: https://thesecretskincare.com/wpm@060a39adw5cde942bpa0705f3cme9587a17/custom/web-pixel-shopify-custom-pixel@0210/sandbox/modern/cart?auclinicredirect=true&view=641203&cfShowSuccessStep=true
                // by default we use 1000 ms delay before marking form as done, but now the page has redirected before that. so on next page load, the form is not done
                // not sure if its changes from CF form.
                (function() {
                    // quick patch, set update done with no delay
                    let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
                    let reference = cfForm.getFieldValue('reference');
                    if (!loggedIn && reference == 'Clinic') {
                        console.log('DEBUG: Clinic workaround');
                        updateDoneDisplay(true);
                    }
                }());


                setTimeout(function() {
                    let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
                    let reference = cfForm.getFieldValue('reference');

                    console.log('DEBUG: reference', reference);
                    // debugger;

                    if (!loggedIn && reference == 'Clinic') {
                        console.log('DEBUG: non logged in user, and has reference= Clinic, assume its clinic. skip check expiration script');
                        // saveDone(true);
                        updateDoneDisplay(true);
        
                        setTimeout(function() {
                            closeForm();
                        },/*1000*/120);
                    } else {
                        console.log('DEBUG: logged in user, its a retail, not clinic');
                        // checkCFEventsAfterSave(
                        //     // callback success
                        //     function() {
                        //         console.log('DEBUG: form submitted',formId, submissionData, event.target);
                        //         // saveDone(true);
                        //         updateDoneDisplay(true);
                
                        //         setTimeout(function() {
                        //             closeForm();
                        //         },/*1000*/120);
                        //     }, 
                        //     // callback error
                        //     function() {
                        //         alert('Error fetching events, please try again later');
                        //     });    


                        // ClueEdit: legal changes - August
                        console.log('DEBUG: form submitted',formId, submissionData, event.target);
                        updateDoneDisplay(true);
        
                        setTimeout(function() {
                            closeForm();
                        },/*1000*/120);
                        // TODO: remove this, uncomment above, and set timeout to 3500
                        // end of ClueEdit: legal changes - August

                    }

                }, 1000);

            });            

            // step changed
            $cfForm.addEventListener('cf:step_changed', function(event) {
                var cfForm = $cfForm.cfForm;

                // Overriding options
                // some options depend on options from other steps, and can't be handled with CF Rule
                // so need to be done in JS below
                var $cfStepTitle = $cfForm.querySelector('.cf-step-title');
                
                // Primary Skin Concern options depend on Main Skin Concern selected values            
                var mainSkinConcerns;
                var $mainSkinConcernOptions, $primarySkinConcernOptions;
                var mainSkinConcernsDynamic = []; // similar to mainSkinConcerns, but the one that dynamic (because mainskinconcern & primaryskinconcern is in the same step)

                // hide radios while updating mainSkinConcernsDynamic values
                function hideRadios() {
                    app.nodeListToArray($primarySkinConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        el.parentElement.style.display = 'flex';
                        if (mainSkinConcerns.indexOf(value) < 0) {
                            // console.log('DEBUG: hide',value);
                            el.parentElement.style.display = 'none';
                        }
                    });
                }

                function updateMainSkinConcernsDynamic() {
                    mainSkinConcernsDynamic = [];
                    app.nodeListToArray($mainSkinConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        if (el.checked) {
                            mainSkinConcernsDynamic.push(value);
                        };
                    });
                }

                function hideRadiosDynamic() {
                    app.nodeListToArray($primarySkinConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        el.parentElement.style.display = 'flex';
                        if (mainSkinConcernsDynamic.indexOf(value) < 0) {
                            // console.log('DEBUG: hide',value);
                            el.parentElement.style.display = 'none';
                        }
                    });
                }

                if ($cfStepTitle && $cfStepTitle.textContent === 'Skin Concerns') {                    
                    $mainSkinConcernOptions = $cfForm.querySelectorAll('.cfc-list-multiselect input[type="checkbox"][name="list_main_skin_concerns"]');
                    $primarySkinConcernOptions = $cfForm.querySelectorAll('.cfc-list-radios input[type="radio"][name="primary_skin_concern"]');


                    console.log('DEBUG: this is skin concern step!', $mainSkinConcernOptions);
                    mainSkinConcerns = cfForm.getFieldValue('list_main_skin_concerns');
                    console.log('DEBUG: mainSkinConcerns', mainSkinConcerns);
                    console.log('DEBUG: $primarySkinConcernOptions', $primarySkinConcernOptions);

                    // hide initial
                    hideRadios();

                    // hide if user change mainSkinConcernOptions dynamically
                    app.nodeListToArray($mainSkinConcernOptions).forEach(function(el) {
                        el.addEventListener('change', function(ev) {
                            console.log('DEBUG: hide',ev);

                            updateMainSkinConcernsDynamic();

                            var $currentChecked = $cfForm.querySelector('.cfc-list-radios input[type="radio"][name="primary_skin_concern"]:checked');


                            // when primary checked but its not check in main, uncheck it
                            if ($currentChecked) {
                                if (mainSkinConcernsDynamic.indexOf($currentChecked.getAttribute('value')) < 0) {
                                    // we can't just do this, because the form use their own state, that not a dom state
                                    // $currentChecked.checked = false;
                                    
                                    // this reset cf value
                                    cfForm.setFieldValue('primary_skin_concern', undefined);
                                }
                            }

                            console.log('DEBUG: mainSkinConcernsDynamic', mainSkinConcernsDynamic);
                            hideRadiosDynamic();

                            
                        });
                    });

                }

                // ClueEdit: primary eye concern and its fields has removed from MQ
                // eye concern step. only show primary concern options based on main concern options
                // if ($cfStepTitle && $cfStepTitle.textContent === 'Concerns Around The Eye') {                    
                //     $mainEyeConcernOptions = $cfForm.querySelectorAll('.cfc-list-multiselect input[type="checkbox"][name="list_eye_area_main_concern"]');
                //     $primaryEyeConcernOptions = $cfForm.querySelectorAll('.cfc-list-radios input[type="radio"][name="eye_area_primary_concerns"]');

                //     console.log('DEBUG: this is eye concern step!', $mainSkinConcernOptions);
                //     mainEyeConcerns = cfForm.getFieldValue('list_eye_area_main_concern');

                //     // hide initial radios
                //     app.nodeListToArray($primaryEyeConcernOptions).forEach(function(el) {
                //         var value = el.getAttribute('value');
                //         el.parentElement.style.display = 'flex';
                //         if (mainEyeConcerns.indexOf(value) < 0) {
                //             el.parentElement.style.display = 'none';
                //         }
                //     });

                //     // hide if user change mainEyeConcernOptions dynamically
                //     app.nodeListToArray($mainEyeConcernOptions).forEach(function(el) {
                //         el.addEventListener('change', function(ev) {
                //             // console.log('DEBUG: hide',ev);

                //             let mainEyeConcernsDynamic = [];
                //             app.nodeListToArray($mainEyeConcernOptions).forEach(function(el) {
                //                 var value = el.getAttribute('value');
                //                 if (el.checked) {
                //                     mainEyeConcernsDynamic.push(value);
                //                 };
                //             });
        

                //             var $currentChecked = $cfForm.querySelector('.cfc-list-radios input[type="radio"][name="eye_area_primary_concerns"]:checked');


                //             // when primary checked but its not check in main, uncheck it
                //             if ($currentChecked) {
                //                 if (mainEyeConcernsDynamic.indexOf($currentChecked.getAttribute('value')) < 0) {
                //                     // we can't just do this, because the form use their own state, that not a dom state
                //                     // $currentChecked.checked = false;
                                    
                //                     // this reset cf value
                //                     cfForm.setFieldValue('eye_area_primary_concerns', undefined);
                //                 }
                //             }

                //             console.log('DEBUG: mainEyeConcernsDynamic', mainEyeConcernsDynamic);

                //             app.nodeListToArray($primaryEyeConcernOptions).forEach(function(el) {
                //                 var value = el.getAttribute('value');
                //                 el.parentElement.style.display = 'flex';
                //                 if (mainEyeConcernsDynamic.indexOf(value) < 0) {
                //                     // console.log('DEBUG: hide',value);
                //                     el.parentElement.style.display = 'none';
                //                 }
                //             });
        
                            
                //         });
                //     });

                // }

                // // ClueEdit: reset some values when its not considered done
                // var done = sessionStorage.getItem(storageDoneKey);
                // // session storage value is string. need to convert to boolean
                // try {
                //     done = JSON.parse(done);
                // } catch (e) {
                //     done = false;
                // }                

                // var eventDetails = event.detail;
                // var back = false;
                // if (eventDetails && typeof eventDetails === 'object') {
                //     if (eventDetails.fromIndex && eventDetails.toIndex) {
                //         back = (eventDetails.fromIndex > eventDetails.toIndex);
                //     }
                // }

                // if (!done && !back) {
                //     console.log('DEBUG: not done, reset some values', event);

                //     // each time night creams step is shown, reset experience_night_creams value
                //     if ($cfStepTitle && $cfStepTitle.textContent === 'Night Creams') {
                //         console.log('DEBUG: night creams step! reset the experience_night_creams');
                //         cfForm.setFieldValue('experience_night_creams', undefined);
                //         cfForm.setFieldValue('experience_night_creams_1', undefined);
                //         cfForm.setFieldValue('experience_night_creams_2', undefined);
                //     }

                //     // each time Patient Details step is shown, reset init_consultation_confirm, used_prescription_before, arrange_phone_call
                //     if ($cfStepTitle && $cfStepTitle.textContent === 'Patient Details') {
                //         console.log('DEBUG: Patient Details step! reset the init_consultation_confirm, used_prescription_before, arrange_phone_call');
                //         cfForm.setFieldValue('init_consultation_confirm', undefined);
                //         cfForm.setFieldValue('used_prescription_before', undefined);
                //         cfForm.setFieldValue('arrange_phone_call', undefined);

                //         cfForm.setFieldValue('no_consultation_confirm', undefined);

                //         // medications and medications_others
                //         cfForm.setFieldValue('medications', undefined);
                //         cfForm.setFieldValue('medications_other', undefined);
                //     }

                //     // each time Upload Photos step is shown, reset values
                //     if ($cfStepTitle && $cfStepTitle.textContent === 'Upload Photos') {
                //         console.log('DEBUG: Upload Photos step!');
                //         cfForm.setFieldValue('file_photo1', undefined);
                //         cfForm.setFieldValue('file_photo2', undefined);
                //         cfForm.setFieldValue('file_photo3', undefined);

                //         // hacky way to remove the image preview
                //         setTimeout(function(){
                //             var removeFileButtons = document.querySelectorAll('.cf-file-preview.cf-file-image .cf-remove');
                //             console.log('remove buttons', removeFileButtons);
                //             if (removeFileButtons.length) {
                //                 removeFileButtons.forEach(function(button) {
                //                     button.click();
                //                 });    
                //             }                        
                //         },120);
                //     }
                // }


            });    


        });

    };

    app.resultList = function (id) {

        var el = document.getElementById(id);
        if (!el) {
            return false;
        }

        var skinQuizUrl = '/pages/skin-quiz';

        var output = '';
        CF.customerReady(function () {
            var field, fieldType, value, label, quizStep;
            for (field in cusDataMap) {
                if (cusDataMap.hasOwnProperty(field)) {
                    fieldType = cusDataMap[field].type || 'text';
                    value = CF.customer.get(field);
                    value = getFieldValueByType(fieldType, value);
                    label = cusDataMap[field].label;
                    quizStep = cusDataMap[field].quizStep;

                    if (label) {
                        if (quizStep) {
                            output += `<a href="${skinQuizUrl}#initial-step-title=${quizStep}">`;
                        }
                        output += `<strong>${label}:</strong>`;

                        if (fieldType === 'file') {
                            output += `<img src="${value}" style="width:100px; height:auto;" />`;
                        } else {
                            output += `${value}`;
                        }

                        if (quizStep) {
                            output += '</a>';
                        }
                        output += '<br>';
                    }

                    // console.log('DEBUG: result list ', value);
                }
            }
            
            console.log('DEBUG: print result list', output);
            el.innerHTML = output;
    
        });


    };

    var getStepIndexByTitle = function(initialStepTitle) {
        var index = quizStepTitle.indexOf(initialStepTitle);
        console.log('DEBUG: get step by title, index', index, quizStepTitle);
        return (index >= 0)?index:0;
    };


    function calculateAge(birthMonth,birthDay,birthYear) {
        var todayDate = new Date();
        var todayYear = todayDate.getFullYear();
        var todayMonth = todayDate.getMonth();
        var todayDay = todayDate.getDate();
        var age = todayYear - birthYear;
    
        if ( todayMonth < (birthMonth - 1))
        {
            age--;
        }
        if (((birthMonth - 1) == todayMonth) && (todayDay < birthDay))
        {
            age--;
        }
        return age;
    }    

    app.quizForm = function () {
        // Form API
        var $form = document.querySelector('form[data-cf-form]');
        var $prev = document.querySelector('.SkinQuiz__HeaderPrev');
        var $progressBar = document.querySelector('.SkinQuiz__ProgressBar > span');

        var formDelegate = new domDelegate.Delegate($form);

        var currentStep = 0;
        var recommendationsUrl = '/collections/recommendations';
        

        CF.ready(function () {
            // Find the first CF form on the page.
            var cfForm = $form.cfForm;
            console.log('DEBUG: my form is ready!!!');

            // redirect to clinic form if needed
            let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
            let clinicName = CF.customer.get('clinic_name'); //cfForm.getFieldValue('clinic_name');
            let reference = CF.customer.get('reference'); //cfForm.getFieldValue('reference');

            console.log('DEBUG: clinicName', clinicName, 'reference', reference);

            if (!loggedIn && clinicName && reference == 'Clinic') {
                if (!containsQueryString('clinicredirect')) {
                    // alert('DEBUG: july!!!');
                    console.log('DEBUG: clinic redirect');
                    // to prevent shopify cache the querystring value
                    // window.location.href = "/pages/skin-quiz?clinicredirect=true&viewx="+getRandomInt(0,999999); //ClueEdit: this does not work

                    window.location.href = "/pages/skin-quiz?clinicredirect=true&view="+getRandomInt(0,999999)+"&view=skinquiz-form";
                }
            }


            // initial step
            var initialStep = app.getHashValue('initial-step');
            console.log('DEBUG: initial step', initialStep);

            var initialStepTitle = app.getHashValueKeepCase('initial-step-title');
            console.log('DEBUG: initial step title', decodeURIComponent(initialStepTitle));

            if (initialStepTitle && initialStepTitle.length) {
                currentStep = getStepIndexByTitle( decodeURIComponent( initialStepTitle));
            } else if (initialStep || initialStep === '0') {
                currentStep = parseInt(initialStep);
            } else {
                currentStep = 0;
            }

            cfForm.goToStep(currentStep, false);
            
            // previous button
            $prev.addEventListener('click', function() {
                cfForm.goToStep(currentStep - 1, false);
            }, false);
            
            // begin button
            formDelegate.on('click', '.cfc-begin-button', function(ev) {
                // console.log('DEBUG: begin clicked');
                cfForm.goToStep(1, false);
                ev.preventDefault();
            }, false);
            

            cfForm.beforeSave(() => {
                console.log('DEBUG: before saved!!!');

                /* TODO: delete below
                // console.log('DEBUG: this is primary concern step!');
                var mainSkinConcerns = cfForm.getFieldValue('list_main_skin_concerns');
                
                if (mainSkinConcerns.length === 1) {
                    console.log('DEBUG: BUGFIX ❕❕❕ only contains 1 main skin concern');                        
                    cfForm.setFieldValue('primary_skin_concern', mainSkinConcerns[0]);
                }    

                // reset '-' value
                // NOTE: this is not working. see gotchas below..
                if (cfForm.getFieldValue('primary_skin_concern') === '-') {
                    cfForm.setFieldValue('primary_skin_concern', undefined);
                }
                
                // we also need to check step after Primary Eye Concern
                // There is rules stup in app: when main eye concern has only 1 entry, hide "Primary Concern Around the Eye"
                // so when this happen, we need to set value of primary eye concern with same value as main eye concern
                var mainEyeConcerns = cfForm.getFieldValue('list_eye_area_main_concern');
                
                if (mainEyeConcerns.length === 1) {
                    console.log('DEBUG: BUGFIX ❕❕❕ only contains 1 main eye concern', mainEyeConcerns[0]);
                    // $form.cfForm.setFieldValue('eye_area_primary_concerns', undefined);
                    cfForm.setFieldValue('eye_area_primary_concerns', mainEyeConcerns[0]);
                    // ISSUE: looks like value can only be set when the field is present in the step
                    console.log('DEBUG: after change value', cfForm.getFieldValue('eye_area_primary_concerns'));
                }    

                // NOTE: gotchas. for some reason above is not working except we add additional rule in form configuration
                //         to set value to '-' when there's only 1 selected option in main concern
                //         once the value is '-', above code is working

                // reset '-' value
                // NOTE: this is not working. see gotchas above..
                if (cfForm.getFieldValue('eye_area_primary_concerns') === '-') {
                    // console.log('DEBUG: BUGFIX ❕❕❕ 🎉🎉🎉');                        
                    cfForm.setFieldValue('eye_area_primary_concerns', undefined);
                }
                */

                // loader
                var $loader = $form.querySelector('.cfc-loader');
                console.log('DEBUG: loader', $loader);
                if ($loader) {
                    $loader.classList.add('cfc-loader-show');
                }    

                // ClueEdit: Legal Changes
                // we are not using redirection in form config anymore, because we need to check data changes after submit
                // change seconds from 3500 to 1. probably we can even delete this
                // delay will be done on cf:form_submitted event

                // show animation longer
                const myPromise = new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve();
                }, 1);
                });                

                return myPromise;

            });
        });

        // submission failed
        $form.addEventListener('cf:form_submission_failed', function(event) {
            var $loader = $form.querySelector('.cfc-loader');
            if ($loader) {
                $loader.classList.remove('cfc-loader-show');
            }
            
        });     


        $form.addEventListener('cf:step_changed', function(event) {
            var cfForm = $form.cfForm;
            var formId = event.detail.formId;
            var fromIndex = event.detail.fromIndex;
            var toIndex = event.detail.toIndex;
          
            console.log('DEBUG"step changed', formId, fromIndex, toIndex/*, event.target*/);
            // -> "a39Jk2", 0, 1, <form data-cf-form="n89j3k">

            // add attribute data-cfc-step to the form step, for easier styling
            var $formStep = $form.querySelector('.cf-form-step');
            $formStep.setAttribute('data-cfc-step', toIndex);
            console.log('DEBUG: form', $formStep );

            currentStep = toIndex;    
            
            // for accurate progress bar, we can't rely on quizStepTitle.length, because actual step is not static due to the rules that can skip or add certain steps
            // we need to rely on cf-step-counter, the value patter is like "Step 3 of 15"
            var $cfStepCounter = $form.querySelector('.cf-step-counter');
            var counterText = $cfStepCounter.textContent;
            counterText = counterText.substring(5).split(' of ');
            var counterCurrentStep, counterMaxStep;
            console.log('DEBUG: counterText', counterText);
            if (counterText && counterText.length) {
                counterCurrentStep = parseInt(counterText[0]);
                counterMaxStep = parseInt(counterText[1]);

                if (counterCurrentStep && counterMaxStep) {
                    $progressBar.style.width = ((counterCurrentStep-1) / (counterMaxStep-1) * 100) + '%';                    
                }

                console.log('DEBUG: step', counterCurrentStep, counterMaxStep);
            }

            // $progressBar.style.width = ((toIndex) / quizStepTitle.length * 100) + '%';




            // Overriding options
            // some options depend on options from other steps, and can't be handled with CF Rule
            // so need to be done in JS below
            var $cfStepTitle = $form.querySelector('.cf-step-title');
            
            // Primary Skin Concern options depend on Main Skin Concern selected values            
            var mainSkinConcerns;
            var $primarySkinConcernOptions = $form.querySelectorAll('.cfc-boxed-radios input[type="radio"]');

            if ($cfStepTitle && $cfStepTitle.textContent === 'Primary Skin Concern') {
                // console.log('DEBUG: this is primary concern step!');
                mainSkinConcerns = cfForm.getFieldValue('list_main_skin_concerns');

                app.nodeListToArray($primarySkinConcernOptions).forEach(function(el) {
                    var value = el.getAttribute('value');
                    if (mainSkinConcerns.indexOf(value) < 0) {
                        // console.log('DEBUG: hide',value);
                        el.parentElement.style.display = 'none';
                        // el.parentElement.style.background = 'fuchsia';

                        // uncheck option when its supposed to be hidden but previously selected
                        if (el.checked) {
                            // console.log('DEBUG: need to uncheck', value);
                            cfForm.setFieldValue('primary_skin_concern', undefined);
                        }
                    }
                });


                
                // ClueEdit: new skinquiz 1.107 - not needed anymore
                // // if no acne selected, we also need to clear up any values in step 3.1, 3.2, 3.3 (additional acne steps)
                // if (mainSkinConcerns.indexOf('Acne and/or breakouts') < 0) {
                //     console.log('DEBUG: clear up acne values');
                //     cfForm.setFieldValue('weekly_breakouts', undefined);
                //     cfForm.setFieldValue('list_breakouts_location', undefined);
                //     // cfForm.setFieldValue('list_breakouts_appearance', undefined);
                // }

                // ClueEdit: new skinquiz 1.107 - not needed anymore
                // // if no rosacea selected, clear up rosacea_severity
                // if (mainSkinConcerns.indexOf('Rosacea') < 0) {
                //     console.log('DEBUG: clear up rosacea values');
                //     cfForm.setFieldValue('rosacea_severity', undefined);
                // }

                // if only 1 options (main skin concern only contains 1), set the value same as main skin concern and skip this step                
                if (mainSkinConcerns.length === 1) {
                    // console.log('DEBUG: BUGFIX ❕❕❕ only contains 1 main skin concern');                        
                    cfForm.setFieldValue('primary_skin_concern', mainSkinConcerns[0]);

                    // skip this step
                    if (toIndex > fromIndex) {
                        // when forward
                        cfForm.goToNextStep();
                    } else {
                        // when backward
                        cfForm.goToPreviousStep();
                    }
                }    

            }
            






            // Primary Eye Area Concern options depend on Main Eye Area Concern selected values
            var mainEyeConcerns;
            var $primaryEyeConcernOptions = $form.querySelectorAll('.cfc-boxed-radios input[type="radio"]');
            if ($cfStepTitle && $cfStepTitle.textContent === 'Primary Concern Around the Eye') {
                // console.log('DEBUG: this is primary concern step!');
                mainEyeConcerns = cfForm.getFieldValue('list_eye_area_main_concern');
                // console.log('DEBUG: this is eye primary concern step!, mainEyeConcerns', mainEyeConcerns);

                app.nodeListToArray($primaryEyeConcernOptions).forEach(function(el) {
                    var value = el.getAttribute('value');
                    if (mainEyeConcerns.indexOf(value) < 0) {
                        // console.log('DEBUG: hide',value);
                        el.parentElement.style.display = 'none';
                        // el.parentElement.style.background = 'fuchsia';

                        if (el.checked) {
                            // console.log('DEBUG: need to uncheck', value);
                            cfForm.setFieldValue('eye_area_primary_concerns', undefined);
                        }
                    }
                });

                // when main concern only contains 1 value, automatically choose it as primary concern and then skip the step                
                if (mainEyeConcerns.length === 1) {
                    console.log('DEBUG: only contains 1 main eye concern', mainEyeConcerns[0]);
                    cfForm.setFieldValue('eye_area_primary_concerns', mainEyeConcerns[0]);

                    // skip this step, when forward
                    if (toIndex > fromIndex) {
                        cfForm.goToNextStep();
                    } else {
                        // when backward
                        cfForm.goToPreviousStep();
                    }
                }    

            }

            // ClueEdit: new skinquiz 1.107 - not needed anymore
            // // if male, remove answers about pregnancy
            // // NOTE: unfortunately this only work in front end. any undefined value will be ignored when saving. so the CF still stores old values
            // // ClueEdit: telehealth 1.78 is removing conceive in Retail MQ. code below should has no conflict
            // (function(){
            //     if ($cfStepTitle && $cfStepTitle.textContent === 'Skincare Usage') {  // step after Pregnancy
            //         var sex = cfForm.getFieldValue('sex');
                    
            //         if (sex === 'Male' || sex === 'Transwoman (MTF)') {
            //             cfForm.setFieldValue('pregnant', undefined);
            //             cfForm.setFieldValue('conceive', undefined);
            //             cfForm.setFieldValue('pregnancy_safe', undefined);
            //             cfForm.setFieldValue('breastfeeding', undefined);
    
            //             console.log('DEBUG: clear pregnancy related questions');
            //         }    
            //     }    
            // }());


        });        

        $form.addEventListener('cf:form_submitted', function(event) {
            var formId = event.detail.formId;
            var submissionData = event.detail.submissionData;
            var cfForm = $form.cfForm;
          
            console.log('DEBUG: ',formId, submissionData, event.target);
            // -> "a39Jk2", { first_name: 'John', last_name: 'Smith', ... }, <form data-cf-form="n89j3k">

            // NOTE: In Customer Form configuration, make sure Redirect Options is set to "Display success step after submitting"            
            // So in this stage we assume that we are now in success step
            // UPDATE: looks like this is deprecated because the form setting is now redirect, not displaying success step

            var $loader = $form.querySelector('.cfc-loader');
            console.log('DEBUG: loader', $loader);
            if ($loader) {
                $loader.classList.add('cfc-loader-show');
            }    

            console.log('DEBUG: skin quiz form submitted 💪💪💪💪💪💪💪💪💪');
            
            (function() {
                let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
                let firstName = CF.customer.get('first_name');
                let lastName = CF.customer.get('last_name');
                let email = CF.customer.get('email');
                let phone = CF.customer.get('phone');

                if (loggedIn) {
                    console.log('DEBUG: logged in user, send webhook', firstName, lastName, email, phone);
                } else {
                    console.log('DEBUG: non logged in user, send webhook', firstName, lastName, email, phone);
                }

                let jsonBody = JSON.stringify({
                        first_name: firstName,
                        last_name: lastName,
                        email: email,
                        phone: phone
                    });
                fetch('https://hooks.zapier.com/hooks/catch/20205932/20eni2g/', {
                    method: 'POST',
                    /*headers: {
                        'Content-Type': 'application/json'
                    },*/
                    body: jsonBody
                }).then(function(response) {
                    console.log('DEBUG: webhook sent', response);
                }).catch(function(error) {
                    console.error('DEBUG: webhook error', error);
                });

            })();
            

            // give some time to play animation, also to give a bit threshold between submit and fetching events history
            setTimeout(function() {
                // ClueEdit: Legal Changes
                console.log('DEBUG: skin quiz - check expiration script 💲💲💲💲💲💲💲💲💲💲💲');
                
                let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
                let reference = cfForm.getFieldValue('reference');



                if (!loggedIn && reference == 'Clinic') {
                    console.log('DEBUG: non logged in user and reference=Clinic, assume its clinic. skip check expiration script');
                    window.location.href = recommendationsUrl;
                } else {
                    console.log('DEBUG: logged in user, its a retail, not clinic');

                    // checkCFEventsAfterSave(
                    //     // callback success
                    //     function() {
                    //         console.log('DEBUG: go to recommendation page'); 
                    //         window.location.href = recommendationsUrl;
                    //     }, 
                    //     // callback error
                    //     function() {
                    //         // we still redirect anyway
                    //         console.log('DEBUG: Error fetching events, but go to recommendation page');
                    //         window.location.href = recommendationsUrl;
                    //     });

                    // ClueEdit: Legal Changes - August
                    console.log('DEBUG: go to recommendation page'); 
                    window.location.href = recommendationsUrl;
                    // TODO: uncomment above
                    // ClueEdit: end of Legal Changes - August
                    
                }





            }, 3500);
          });

        $form.addEventListener('cf:form_submission_failed', function(event) {
            var formId = event.detail.formId;
            var errors = event.detail.errors;
          
            console.log('DEBUG: submission failed',formId, errors, event.target);
            if (errors && typeof errors == 'object') {
                console.log('DEBUG: errors', errors);
                // check if there's error['email'] = "has already been taken"
                console.log(errors['email']);
                console.log(typeof errors['email']);
                console.log(errors['email'][0]);
                if (errors['email'] && Array.isArray(errors['email']) && errors['email'][0] === 'has already been taken') {
                    // alert('DEBUG: email has already been taken');
                    
                    window.setTimeout(function() {
                        console.log('DEBUG: append button here');
                        // add link button after element with class .cf-form-errors
                        var $cfFormErrors = document.querySelector('.cf-form-errors');
                        var $link = document.createElement('a');
                        //  add class to make it looks like button
                        $link.classList.add('btn');
                        $link.classList.add('button');
                        // add style margin-top: 15px
                        $link.style.marginTop = '15px';
                        $link.href = '/account/login?return_url=/pages/redirection/pages--skin-quiz';
                        $link.textContent = 'Click here to Login';
                        $cfFormErrors.appendChild($link);                        
                    },500);
                }
                // href="/account/login?return_url=/pages/redirection/pages--skin-quiz"

            }
        });
    };

    app.partnerQuizForm = function () {
        // Find the first CF form on the page.
        var $cfForm = document.querySelector('form[data-cf-form]');
        var cfForm = $cfForm.cfForm;
        var $partnerSkinQuiz = document.querySelector('.PartnerSkinQuiz');

        var PASSWORD = 'TSS2024';


        // login form
        var $loginForm = document.querySelector('.PartnerSkinQuiz__Login');
        var $password = $loginForm.querySelector('#PartnerSkinQuiz__Password');
        var $submit = $loginForm.querySelector('#PartnerSkinQuiz__Submit');
        var $message = $loginForm.querySelector('.PartnerSkinQuiz__Message');
        var storagePartnerLoginKey = 'cd-cart-partner-logged-in';

        function partnerLogin() {
            var loggedIn = sessionStorage.getItem(storagePartnerLoginKey);
            if (loggedIn === 'true') {
                console.log('DEBUG: logged in');

                $partnerSkinQuiz.classList.add('PartnerSkinQuiz--active');
            }
        }

        function clearGuestData() {
            console.log('DEBUG: clear guest data');
            localStorage.removeItem('cf:guest_data');
        }

        function clearCart() {
            fetch('/cart/clear.js', {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header        
            }
            }).then(function () {
            console.log('DEBUG: Cart cleared');               
            });
        }

        clearGuestData();
        partnerLogin();
        clearCart();

        $password.addEventListener('keyup', function(ev) {
            $message.style.display = 'none';
        });

        $submit.addEventListener("click", function(ev) {
            console.log('DEBUG: password click');
            if ($password.value === PASSWORD) {
                console.log('DEBUG: password correct');
                sessionStorage.setItem(storagePartnerLoginKey, 'true');
                partnerLogin();
            } else {
                console.log('DEBUG: password wrong');
                $message.style.display = '';
            }
        });




        CF.ready(function () {
            console.log('DEBUG: Partner Quiz Form 💲💲💲💲💲💲💲💲💲💲💲💲💲💲');
            // Find the first CF form on the page.
            var $cfForm = document.querySelector('form[data-cf-form]');
            var cfForm = $cfForm.cfForm;

            console.log('DEBUG: my form is ready!!!');

            
            cfForm.beforeSave(() => {
                console.log('DEBUG: before saved!!!');

                // var mainSkinConcerns = cfForm.getFieldValue('list_main_skin_concerns');
                // // if main skin concern only contains 1, set the value same as main skin concern and skip this step                
                // if (mainSkinConcerns.length === 1) {
                //     console.log('DEBUG: BUGFIX ❕❕❕ only contains 1 main skin concern, set primary_skin_concern to ',mainSkinConcerns[0]);                        
                //     cfForm.setFieldValue('primary_skin_concern', mainSkinConcerns[0]);
                // }                                


                // // loader
                // var $loader = $form.querySelector('.cfc-loader');
                // console.log('DEBUG: loader', $loader);
                // if ($loader) {
                //     $loader.classList.add('cfc-loader-show');
                // }    

                // // show animation longer
                // const myPromise = new Promise((resolve, reject) => {
                // setTimeout(() => {
                //     resolve();
                // }, 100);
                // });                

                // return myPromise;
            });



            $cfForm.addEventListener('cf:step_changed', function(event) {
                // TODO:
                // 1427 - primary skin concern options depend on main skin concern selected value
                // 1466 - set the primary_skin_concern value if main only 1 selected
            
                // do the same for eye area
                // primary & main - 1490
            
                var cfForm = $cfForm.cfForm;
                var $cfStepTitle = $cfForm.querySelector('.cf-step-title');
            
                
                
                
                // Primary Skin Concern options depend on Main Skin Concern selected values            
                var mainSkinConcerns;
                var $mainSkinConcernOptions, $primarySkinConcernOptions, $primarySkinConcernFields;
                var mainSkinConcernsDynamic = []; // similar to mainSkinConcerns, but the one that dynamic (because mainskinconcern & primaryskinconcern is in the same step)


                // Primary Eye Concern options depend on Main Eye Concern selected values            
                var mainEyeAreaConcerns;
                var $mainEyeAreaConcernOptions, $primaryEyeAreaConcernOptions, $primaryEyeAreaConcernFields;
                var mainEyeAreaConcernsDynamic = []; // similar to mainEyeAreaConcerns, but the one that dynamic (because mainEyeAreaConcern & primaryEyeAreaConcern is in the same step)



            
                // hide radios while updating mainSkinConcernsDynamic values
                function hidePrimarySkinConcernRadios() {
                    app.nodeListToArray($primarySkinConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        el.parentElement.style.display = 'flex';
                        if (mainSkinConcerns.indexOf(value) < 0) {
                            // console.log('DEBUG: hide',value);
                            el.parentElement.style.display = 'none';
                        }
                    });
                }
            
                function updateMainSkinConcernsDynamic() {
                    mainSkinConcernsDynamic = [];
                    app.nodeListToArray($mainSkinConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        if (el.checked) {
                            mainSkinConcernsDynamic.push(value);
                        };
                    });
                }
            
                function hidePrimarySkinConcernRadiosDynamic() {
                    app.nodeListToArray($primarySkinConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        el.parentElement.style.display = 'flex';
                        if (mainSkinConcernsDynamic.indexOf(value) < 0) {
                            // console.log('DEBUG: hide',value);
                            el.parentElement.style.display = 'none';
                        }
                    });
                }
            
                function showFields($els, show) {
                    app.nodeListToArray($els).forEach(function(el) {
                        if (show) {
                            el.style.display = '';
                        } else {
                            el.style.display = 'none';
                        }
                    });
                }

                function hideShowPrimarySkinConcernFields(mainData,primaryEl) {
                    if (mainData.length <= 1) {
                        // hide
                        showFields(primaryEl, false);
                    } else {
                        showFields(primaryEl, true);
                    }    
                }

                // hide radios while updating mainEyeAreaConcernsDynamic values
                function hidePrimaryEyeAreaConcernRadios() {
                    app.nodeListToArray($primaryEyeAreaConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        el.parentElement.style.display = 'flex';
                        if (mainEyeAreaConcerns.indexOf(value) < 0) {
                            // console.log('DEBUG: hide',value);
                            el.parentElement.style.display = 'none';
                        }
                    });
                }

                function updateMainEyeAreaConcernsDynamic() {
                    mainEyeAreaConcernsDynamic = [];
                    app.nodeListToArray($mainEyeAreaConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        if (el.checked) {
                            mainEyeAreaConcernsDynamic.push(value);
                        };
                    });
                }

                function hidePrimaryEyeAreaConcernRadiosDynamic() {
                    app.nodeListToArray($primaryEyeAreaConcernOptions).forEach(function(el) {
                        var value = el.getAttribute('value');
                        el.parentElement.style.display = 'flex';
                        if (mainEyeAreaConcernsDynamic.indexOf(value) < 0) {
                            // console.log('DEBUG: hide',value);
                            el.parentElement.style.display = 'none';
                        }
                    });
                }



                if ($cfStepTitle && $cfStepTitle.textContent === "Patient’s Skin Profile") {                    
                    console.log('DEBUG: step changed to patients skin profile');
                    
                    $mainSkinConcernOptions = $cfForm.querySelectorAll('.cfc-list-multiselect input[type="checkbox"][name="list_main_skin_concerns"]');
            
                    $primarySkinConcernOptions = $cfForm.querySelectorAll('.cfc-list-radios input[type="radio"][name="primary_skin_concern"]');
                    $primarySkinConcern = $primarySkinConcernOptions[0].closest('.cf-field-container');

                    $primarySkinConcernFields = $cfForm.querySelectorAll('.cf-field-container.cfc-primary-skin-concern');
            
                    mainSkinConcerns = cfForm.getFieldValue('list_main_skin_concerns');
            
                    // hide initial
                    hidePrimarySkinConcernRadios();

                    updateMainSkinConcernsDynamic();
                    hideShowPrimarySkinConcernFields(mainSkinConcernsDynamic, $primarySkinConcernFields);
                    
                    // hide if user change mainSkinConcernOptions dynamically
                    app.nodeListToArray($mainSkinConcernOptions).forEach(function(el) {
                        el.addEventListener('change', function(ev) {
                            console.log('DEBUG: hide',ev);
            
                            updateMainSkinConcernsDynamic();
            
                            var $currentChecked = $cfForm.querySelector('.cfc-list-radios input[type="radio"][name="primary_skin_concern"]:checked');
            
            
                            // when primary checked but its not check in main, uncheck it
                            if ($currentChecked) {
                                if (mainSkinConcernsDynamic.indexOf($currentChecked.getAttribute('value')) < 0) {
                                    // we can't just do this, because the form use their own state, that not a dom state
                                    // $currentChecked.checked = false;
                                    
                                    // this reset cf value
                                    cfForm.setFieldValue('primary_skin_concern', undefined);
                                }
                            }

                            // console.log('DEBUG: test 💲', mainSkinConcernsDynamic);
                            // if main skin concern only contains 1, set the value same as main skin concern and skip this step                

                            hideShowPrimarySkinConcernFields(mainSkinConcernsDynamic, $primarySkinConcernFields);
            
                            // console.log('DEBUG: mainSkinConcernsDynamic', mainSkinConcernsDynamic);
                            hidePrimarySkinConcernRadiosDynamic();
            


                        });
                    });




                    // eye area
                    $mainEyeAreaConcernOptions = $cfForm.querySelectorAll('.cfc-list-multiselect input[type="checkbox"][name="list_eye_area_main_concern"]');

                    $primaryEyeAreaConcernOptions = $cfForm.querySelectorAll('.cfc-list-radios input[type="radio"][name="eye_area_primary_concerns"]');
                    $primaryEyeAreaConcernFields = $cfForm.querySelectorAll('.cf-field-container.cfc-primary-eye-area-concern');

                
                    mainEyeAreaConcerns = cfForm.getFieldValue('list_eye_area_main_concern');
                
                    // hide initial
                    hidePrimaryEyeAreaConcernRadios();

                    updateMainEyeAreaConcernsDynamic();
                    hideShowPrimarySkinConcernFields(mainEyeAreaConcernsDynamic, $primaryEyeAreaConcernFields);

                
                    // hide if user change mainEyeAreaConcernOptions dynamically
                    app.nodeListToArray($mainEyeAreaConcernOptions).forEach(function(el) {
                        el.addEventListener('change', function(ev) {
                            console.log('DEBUG: hide',ev);
                
                            updateMainEyeAreaConcernsDynamic();
                
                            var $currentChecked = $cfForm.querySelector('.cfc-list-radios input[type="radio"][name="eye_area_primary_concerns"]:checked');
                
                
                            // when primary checked but its not check in main, uncheck it
                            if ($currentChecked) {
                                if (mainEyeAreaConcernsDynamic.indexOf($currentChecked.getAttribute('value')) < 0) {
                                    // we can't just do this, because the form use their own state, that not a dom state
                                    // $currentChecked.checked = false;
                                    
                                    // this reset cf value
                                    cfForm.setFieldValue('eye_area_primary_concerns', undefined);
                                }
                            }

                            hideShowPrimarySkinConcernFields(mainEyeAreaConcernsDynamic, $primaryEyeAreaConcernFields);


                            console.log('DEBUG: mainEyeAreaConcernsDynamic', mainEyeAreaConcernsDynamic);
                            hidePrimaryEyeAreaConcernRadiosDynamic();
                
                            
                        });
                    });                
                    
            
                }

                // step after Patient’s Skin Profile
                if ($cfStepTitle && $cfStepTitle.textContent === "Current Skin Care") {                    
                    
                    mainSkinConcerns = cfForm.getFieldValue('list_main_skin_concerns');
                    // if main skin concern only contains 1, set the value same as main skin concern and skip this step                
                    if (mainSkinConcerns.length === 1) {
                        console.log('DEBUG: BUGFIX ❕❕❕ only contains 1 main skin concern, set primary_skin_concern to ',mainSkinConcerns[0]);                        
                        cfForm.setFieldValue('primary_skin_concern', mainSkinConcerns[0]);
                    }    
                    

                    mainEyeAreaConcerns = cfForm.getFieldValue('list_eye_area_main_concern');
                    // if main skin concern only contains 1, set the value same as main skin concern and skip this step                
                    if (mainEyeAreaConcerns.length === 1) {
                        console.log('DEBUG: BUGFIX ❕❕❕ only contains 1 main eye area concern, set eye_area_primary_concerns to ',mainEyeAreaConcerns[0]);                        
                        cfForm.setFieldValue('eye_area_primary_concerns', mainEyeAreaConcerns[0]);
                    }    
                            
            
                }



                

            
            });        
                
            // submission failed
            $cfForm.addEventListener('cf:form_submission_failed', function(event) {
                // var $loader = $form.querySelector('.cfc-loader');
                // if ($loader) {
                //     $loader.classList.remove('cfc-loader-show');
                // }
                
            });     

            // $cfForm.addEventListener('cf:form_submitted', function(event) {
            //     var formId = event.detail.formId;
            //     var submissionData = event.detail.submissionData;
            
            //     console.log('DEBUG: ',formId, submissionData, event.target);

            //     // give some time to play animation
            //     setTimeout(function() {
            //         console.log('DEBUG: go to recommendation page');
            //         window.location.href = recommendationsUrl;
            //     }, 1000);
            //   });
            
        });







    };


    // as array filter callback, to get unique/distict values
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }    

    // data = from json matrix
    // return { status: (found or not found), products: array of products handle }
    function getRecommendedProducts(data) {
        // final recommended products
        products = [];

        // included & excluded products per question group
        // will be: 
        /*
            {
                'list_allergic_ingredients': {
                    y: [],  // included
                    n: [],  // excluded
                    yo: []  // yoverride = y that stronger than n
                },
                ...
            }
        */
        QuestionGroupProducts = {};

        // final included & excluded products
        includedProducts = [];
        excludedProducts = [];

        // build key pairs of current questions
        var yourAnswers = [];

        var fieldType, value, recommendation;
        for (field in cusDataMap) {
            if (cusDataMap.hasOwnProperty(field)) {
                fieldType = cusDataMap[field].type || 'text';
                value = CF.customer.get(field);
                // console.log('DEBUG: ', field, CF.customer.get(field));
                value = getFieldValueByType(fieldType, value);
                // console.log('DEBUG: ', field, value);
                // label = cusDataMap[field].label;
                // quizStep = cusDataMap[field].quizStep;
                recommendation = cusDataMap[field].recommendation;

                if (recommendation && value) {

                    // ClueEdit: new skinquiz doesn't ask sex anymore, since 1.107
                    // // filter pregnancy related
                    // // ClueEdit: telehealth 1.78 is removing conceive in Retail MQ. code below should has no conflict
                    // if (['pregnant', 'conceive', 'pregnancy_safe', 'breastfeeding'].indexOf(field) > -1) {
                    //     let sex = CF.customer.get('sex');
                    //     if (sex === 'Male' || sex === 'Transwoman (MTF)') {
                    //         console.log('DEBUG: exclude pregnany related values');
                    //         continue;
                    //     }
                    // }


                    // ClueEdit: new skinquiz 1.107 - not needed anymore
                    // // filter acne related
                    // if (['weekly_breakouts','list_breakouts_location'].indexOf(field) > -1) {
                    //     let ignore = false;
                    //     let mainSkinConcern = CF.customer.get('list_main_skin_concerns');
                    //     let primarySkinConcern = CF.customer.get('primary_skin_concern');

                    //     // when main skin concern doesn't contain acne, ignore
                    //     if ((typeof mainSkinConcern === 'array' || typeof mainSkinConcern === 'object') && mainSkinConcern.length && mainSkinConcern.indexOf('Acne and/or breakouts') < 0) {
                    //         console.log('DEBUG: main skin concern does not contain acne, exclude acne related values');
                    //         ignore = true;
                    //     }

                    //     // when primary skin concern is not acne, ignore
                    //     if (primarySkinConcern !== 'Acne and/or breakouts') {
                    //         console.log('DEBUG: primary skin concern is not acne, exclude acne related values');
                    //         ignore = true;
                    //     }

                    //     if (ignore) {
                    //         continue;
                    //     }
                    // }


                    // for data type list with multiple value, create multiple answer
                    // eg: if key = 'list_question1' and value is ['value 1', 'value 2']
                    // then create 2: { question: 'list_question1', value: 'value 1' }, { question: 'list_question1', value: 'value 2' }
                    // console.log('DEBUG: HEY fieldtype ??', fieldType, typeof value, value.length);
                    if (fieldType === 'list' && (typeof value === 'array' || typeof value === 'object')) {
                        if (value.length) {
                        value.forEach(function(listValue) {
                            yourAnswers.push({
                                'question': field,
                                'value': listValue
                            });        
                        });
                    } else {
                            
                        }
                    } else {
                        yourAnswers.push({
                            'question': field,
                            'value': value
                        });    
                    }
                    // console.log('DEBUG: result list ', value);    
                }
            }
        }
        
        var quizTaken = false;
        var mandatoryAnswersAnswered = false;

        // if yourAnswer is empty means user hasn't take the quiz
        if (yourAnswers.length) {
            quizTaken = true;
        }
        


        var mandatoryAnswers = [
            "list_skin_type",
            "list_main_skin_concerns",
            "primary_skin_concern",
            // "list_active_reactions",
            "list_eye_area_main_concern"//,
            // "eye_area_primary_concerns",
            // "sex",
            // "anf_three_months",
            // "cellular_three_months",
            // "hydroquinone_three_months"
        ];

        var yourMandatoryAnswers = [];
        yourAnswers.forEach(function(a) {
            if (mandatoryAnswers.indexOf(a.question) > -1) {
                yourMandatoryAnswers.push(a.question);
            }
        });

        console.log('DEBUG: yourMandatoryAnswers', yourMandatoryAnswers);
        console.log('DEBUG: mandatoryAnswers', mandatoryAnswers);

        if (yourMandatoryAnswers.length >= mandatoryAnswers.length) {
            mandatoryAnswersAnswered = true;
        }

        // ClueEdit: check if clinic
        (function(){
            let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
            let clinicName = CF.customer.get('clinic_name');
            let reference = CF.customer.get('reference');
            if (!loggedIn && clinicName && reference == 'Clinic') {
                document.body.setAttribute('data-clinic', 'true');
            }            
        }());


        if (!( quizTaken && mandatoryAnswersAnswered )) {
            console.log('DEBUG: You havent take a quiz');
            document.body.setAttribute('data-quiz-check', 'quiz-not-taken');

            return {
                status: app.RECOMMENDATION_STATUS.NODATA,
                products: []
            };
        }

        document.body.setAttribute('data-quiz-check', 'quiz-taken');

        // ClueEdit: age is not in skin quiz anymore (since theme 1.107)
        // // set age value
        // var birthdayMonth = CF.customer.get('birthday_month');
        // var birthdayYear = CF.customer.get('birthday_year');
        // var birthdayDay = CF.customer.get('birthday_day') || 1; // default 1, because birthday day is not asked in quiz
        // var age = calculateAge(birthdayMonth, birthdayDay, birthdayYear);
        // age = (age >= 18)?'> 18':'< 18';
        // yourAnswers.push({
        //     'question': 'age',
        //     'value': ''+ age
        // });    

        // acne night formula II
        var addANFII = false;

        // skin type is dehydrated only
        var skinTypeAnswers = [];

        var pregnantAnswer = null,
        conceiveAnswer = null,
        pregnancySafeAnswer = null;

        // ClueEdit: new skinquiz 1.107 answer logic
        var eyeAreaMainConcernAnswers = [];
        var individualOrSetAnswers = [];
        var primaryConcernAnswer = null;
        var includeBaseRangeAnswer = null;
        var spf50Answer = null;

        var prescriptionStrengthAnswer = null;
        var flakingPeelingAnswer = null;

        var recommendationsSummary = 'RECOMMENDATIONS SUMMARY\n\n';
        
        recommendationsSummary += 'Your original Answers:\n';
        yourAnswers.forEach(function(answer) {
            recommendationsSummary += `   ${answer.question}: ${answer.value}\n`;
        });

        // other additional logic
        (function(){
            if (!yourAnswers.length) {
                return false;
            }
            var i,a;
            var breakoutFaceCount = 0;


            // patient under 18 that need acne night formula I
            var under18needANFI = false,
                // primaryConcernAnswer = null,
                anfThreeMonthAnswer = null;

            for (i=0; i<yourAnswers.length; i++) {
                a = yourAnswers[i];

                // ClueEdit: new skinquiz 1.107 - not needed anymore
                // // update value for list_breakouts_location, If more than one areas of the face is ticked
                // if (a.question === 'list_breakouts_location') {
                //     if (a.value === 'Mouth/Chin' || 
                //         a.value === 'Nose' ||
                //         a.value === 'Forehead' ||
                //         a.value === 'Between Eyebrows' ||
                //         a.value === 'Cheeks') {
                //             breakoutFaceCount+=1;
                //     }
                // }                

                // ClueEdit: new skinquiz 1.107 - not needed anymore
                // // update value for anf_three_months Yes, which according to matrix is depend on age value
                // // become either Yes - Under 18 and Yes - Over 18
                // if (a.question === 'anf_three_months' && a.value === 'Yes') {
                //     // console.log('DEBUG: Update anf_three_months');
                //     if (age === '> 18') {
                //         a.value = 'Yes - Over 18';
                //     } else {
                //         a.value = 'Yes - Under 18';
                //     }
                //     // break;
                // }

                // cache some answers
                if (a.question === 'pregnant') {
                    pregnantAnswer = a;
                } else if (a.question === 'conceive') {
                    conceiveAnswer = a;
                } else if (a.question === 'pregnancy_safe') {
                    pregnancySafeAnswer = a;
                } 
                
                if (a.question === 'prescription_strength') {
                    prescriptionStrengthAnswer = a;
                }
                if (a.question === 'flaking_peeling') {
                    flakingPeelingAnswer = a;
                }
                // ClueEdit: new skinquiz 1.107 - not needed anymore
                // 
                // else if (a.question === 'primary_skin_concern') {
                //     primaryConcernAnswer = a;
                // } else if (a.question === 'anf_three_months') {
                //     anfThreeMonthAnswer = a;
                // } 


                if (a.question === 'list_skin_type') {
                    skinTypeAnswers.push(a.value);
                }

                // ClueEdit: new skinquiz 1.107 - cache answer for products special condition
                if (a.question === 'list_eye_area_main_concern') {
                    eyeAreaMainConcernAnswers.push(a.value);
                }
                // console.log('DEBUG: eyeAreaMainConcernAnswers', eyeAreaMainConcernAnswers);

                if (a.question === 'individual_product_or_set') {
                    individualOrSetAnswers.push(a.value);
                }
                
                if (a.question === 'primary_skin_concern') {
                    primaryConcernAnswer = a;
                    // console.log('DEBUG: primaryConcernAnswer', primaryConcernAnswer);
                } else if (a.question === 'include_base_range') {
                    includeBaseRangeAnswer = a;
                    // console.log('DEBUG: includeBaseRangeAnswer', includeBaseRangeAnswer);
                } else if (a.question === 'spf50') {
                    spf50Answer = a;
                    // console.log('DEBUG: spf50Answer', spf50Answer);
                }
            }

            // ClueEdit: new skinquiz 1.107 - not needed anymore
            // // update value for list_breakouts_location, If more than one areas of the face is ticked
            // if (breakoutFaceCount > 1) {
            //     yourAnswers.push({
            //         'question': 'list_breakouts_location',
            //         'value': 'More than one areas of the face'
            //     });            
            // }

            // ClueEdit: new skin quiz, since 1.107
            // // special condition: Patients who are trying to conceive and would prefer a pregnancy safe option should be treated as patients who have said yes to pregnant. 
            // if (pregnantAnswer && conceiveAnswer && pregnancySafeAnswer) {
            //     if ((pregnantAnswer.value === 'No') && (conceiveAnswer.value === 'Yes') && (pregnancySafeAnswer.value === 'Yes')) {
            //         console.log('DEBUG: Special condition: Patients who are trying to conceive and would prefer a pregnancy safe option, treated as pregnant');
            //         // set pregnant
            //         pregnantAnswer.value = 'Yes';
    
            //         // remove conceive answer
            //         yourAnswers = yourAnswers.filter(function(an){ 
            //             return an.question !== 'conceive';
            //         });
            //     }    
            // }

            // ClueEdit: new skinquiz 1.107 - not needed anymore
            // // special filter Patients under 18 who have used the Acne Night Formula I in the last 3 months should receive Acne Night Formula II, unless they have selected Rosacea or Dermatitis to be their primary concern. 
            // let primaryRosaceaOrDermatitis = ((primaryConcernAnswer && primaryConcernAnswer.value === 'Rosacea')|| (primaryConcernAnswer && primaryConcernAnswer.value === 'Dermatitis'));
            // if (anfThreeMonthAnswer && anfThreeMonthAnswer.value === 'Yes - Under 18' && !primaryRosaceaOrDermatitis) {
            //     // add acne night formula II
            //     console.log('DEBUG: 💲💲💲 special condition ');
            //     addANFII = true;
            // }

            recommendationsSummary += '\nApplying Answer Conditions Logic:\n';

            // CLueEdit: new skin quiz 1.107 - if individual_product_or_set dont have Set value, remove include_base_range answer
            if (individualOrSetAnswers && individualOrSetAnswers.length >= 1 && individualOrSetAnswers.indexOf('Skincare Set') < 0)
                {
                console.log('DEBUG: 💲💲💲 special condition individual_product_or_set dont have Skincare Set value, remove include_base_range answer');
                recommendationsSummary += '   individual_product_or_set dont have Skincare Set value, remove include_base_range answer\n';
                // remove include_base_range answer
                yourAnswers = yourAnswers.filter(function(an){ 
                    return an.question !== 'include_base_range';
                });
                includeBaseRangeAnswer = null;
            }
            // CLueEdit: new skin quiz 1.107 - if conceive is No, remove pregnancy_safe answer
            if (conceiveAnswer && conceiveAnswer.value === 'No') {
                console.log('DEBUG: 💲💲💲 special condition conceive is no, remove pregnancy_safe answer');
                recommendationsSummary += '   conceive is no, remove pregnancy_safe answer\n';
                // remove include_base_range answer
                yourAnswers = yourAnswers.filter(function(an){ 
                    return an.question !== 'pregnancy_safe';
                });
                pregnancySafeAnswer = null;
            }
            // CLueEdit: new skin quiz 1.107 - if prescription_strength is No, remove flaking_peeling answer
            if (prescriptionStrengthAnswer && prescriptionStrengthAnswer.value === 'No') {
                console.log('DEBUG: 💲💲💲 special condition prescription_strength is no, remove flaking_peeling answer');
                recommendationsSummary += '   prescription_strength is no, remove flaking_peeling answer\n';
                // remove include_base_range answer
                yourAnswers = yourAnswers.filter(function(an){ 
                    return an.question !== 'flaking_peeling';
                });
                flakingPeelingAnswer = null;
            }

        }());

        recommendationsSummary += '\nYour Answers after:\n';
        yourAnswers.forEach(function(answer) {
            recommendationsSummary += `   ${answer.question}: ${answer.value}\n`;
        });


        console.log('DEBUG: your answer', yourAnswers);

        data.forEach(function(q, index) {
            var question = q.question;
            var value = q.value;

            if (!value) {
                return false;
            }

            var column;
            // var cfValue = CF.customer.get(question);
            yourAnswers.forEach(function(answer){
                // console.log('DEBUG: question', question, answer);
                if (question === answer.question && value.toLowerCase() === answer.value.toLowerCase()) {
                    // console.log('DEBUG: match', question, answer.value);

                    // prepare group
                    QuestionGroupProducts[question] = QuestionGroupProducts[question] || { y:[], n:[], yo:[] };

                    // included & excluded products
                    for (column in q) {
                        if (q.hasOwnProperty(column)) {
                            // q contains product handle column, except question & value column, skip them. 
                            if (column === 'question' || column === 'value') {
                                continue;
                            }
                            if (q[column] === 'Y') {
                                // includedProducts.push(column);
                                QuestionGroupProducts[question].y.push(column);
                            } else if (q[column] === 'N') {
                                // excludedProducts.push(column);
                                QuestionGroupProducts[question].n.push(column);
                            } else if (q[column] === 'YO') {
                                QuestionGroupProducts[question].yo.push(column);
                            }
                        }
                    }

                }
            });


            // if ( cfValue && cfValue === value ) {
            //     console.log('DEBUG: question', q.question, value, cfValue);
            // }
        });

        console.log('DEBUG: QuestionGroupProducts - before', QuestionGroupProducts);

        // ClueEdit: new skinquiz 1.107 - not needed anymore
        // // special condition
        // // weekly_breakouts need to be overriden by YO in list_breakouts_location
        // // so, copy YO of list_breakouts_location to weekly_breakouts
        // (function(){
        //     var lbl = QuestionGroupProducts['list_breakouts_location'], 
        //         wb = QuestionGroupProducts['weekly_breakouts'];
        //     if (lbl && wb) {
        //         console.log('DEBUG: special condition where YOverride of list_breakouts_location affecting weekly_breakouts too');
        //         if (lbl.yo && lbl.yo.length) {
        //             wb.yo = wb.yo.concat(lbl.yo);
        //         }
        //     }    
        // }());

        console.log('DEBUG: QuestionGroupProducts - after special condition', QuestionGroupProducts);

        // finalize each QuestionGroupProducts
        // (for y override, which negate excluded)
        (function(){
            var qKey, q, newN;
            for (qKey in QuestionGroupProducts) {
                if (QuestionGroupProducts.hasOwnProperty(qKey)) {
                    // remove items in n array that are also in yo list
                    q = QuestionGroupProducts[qKey];
                    newN = [];
                    q.n.forEach(function(prod) {
                        if (q.yo.indexOf(prod) < 0) {
                            newN.push(prod);
                        }
                    });
                    q.n = newN;

                    // add yo to y list
                    q.y = q.yo.concat(q.y);


                    // then merge to master (excludedProducts and includedProducts)
                    includedProducts = includedProducts.concat(q.y);
                    excludedProducts = excludedProducts.concat(q.n);
                }
            }
        }());
        console.log('DEBUG: QuestionGroupProducts - after', QuestionGroupProducts);

        excludedProducts = excludedProducts.filter(onlyUnique);
        includedProducts = includedProducts.filter(onlyUnique);

        console.log('DEBUG: excluded products', excludedProducts);
        console.log('DEBUG: included products', includedProducts);

        // final products are included product without excluded product
        includedProducts.forEach(function(prod) {
            if (excludedProducts.indexOf(prod) < 0) {
                products.push(prod);
            }
        });
        console.log('DEBUG: products before', products);
        recommendationsSummary += '\nRecommended Products according to matrix (before special conditions):\n';
        recommendationsSummary += products.join(', ');

        recommendationsSummary += '\n\nApplying Special Conditions Logic:\n';

        // ClueEdit: new skinquiz 1.107 - not needed anymore
        // // special filter for Day Birghtening Elixir & Day Brightening Elixir – Sensitive, if both of these recommended, only show Day Birghtening Elixir
        // if (products.indexOf('day-brightening-elixir-dewy') >= 0 && products.indexOf('day-brightening-elixir-sensitive') >= 0) {
        //     console.log('DEBUG: special filter products: when Day Birghtening Elixir & Day Brightening Elixir – Sensitive both recommended');
        //     // remove sensitive
        //     products = products.filter(function(value, index){ 
        //         // return value !== 'day-brightening-elixir-sensitive';
        //         // also include refill version
        //         return !(value === 'day-brightening-elixir-sensitive' /*|| value === 'day-brightening-elixir-sensitive-refill'*/); // ClueEdit : remove -refill from recommendations
        //     });
        // }
        
        // ClueEdit: new skinquiz 1.107 - not needed anymore
        // // special filter for cellular-repair-night-cream, 
        // // if result also recommends cellular-repair-night-cream-sensitive and cellular-repair-night-cream-sensitive-ii, 
        // // just recommend cellular-repair-night-cream
        // if (products.indexOf('cellular-repair-night-cream') >= 0) {
        //     if (products.indexOf('cellular-repair-night-cream-sensitive') >= 0) {
        //         console.log('DEBUG: special filter products: when cellular-repair-night-cream and cellular-repair-night-cream-sensitive, remove cellular-repair-night-cream-sensitive');            
        //         // remove sensitive
        //         products = products.filter(function(value, index){ 
        //             // return value !== 'cellular-repair-night-cream-sensitive';
        //             // also include refill version
        //             return !(value === 'cellular-repair-night-cream-sensitive' /*|| value === 'cellular-repair-night-cream-sensitive-refill'*/); // ClueEdit : remove -refill from recommendations
        //         });    
        //     }
        //     if (products.indexOf('cellular-repair-night-cream-sensitive-ii') >= 0) {
        //         console.log('DEBUG: special filter products: when cellular-repair-night-cream and cellular-repair-night-cream-sensitive-ii, remove cellular-repair-night-cream-sensitive-ii');            
        //         // remove sensitive ii
        //         products = products.filter(function(value, index){ 
        //             // return value !== 'cellular-repair-night-cream-sensitive-ii';
        //             // also include refill version
        //             return !(value === 'cellular-repair-night-cream-sensitive-ii' /*|| value === 'cellular-repair-night-cream-sensitive-ii-refill'*/); // ClueEdit : remove -refill from recommendations
        //         });    
        //     }
        // }

        // ClueEdit: new skinquiz 1.107 - not needed anymore
        // // special filter when cellular-repair-night-cream-sensitive and cellular-repair-night-cream-sensitive-ii, then i win
        // if (products.indexOf('cellular-repair-night-cream-sensitive') >= 0 && products.indexOf('cellular-repair-night-cream-sensitive-ii') >= 0) {
        //     console.log('DEBUG: special filter products: when cellular-repair-night-cream-sensitive & cellular-repair-night-cream-sensitive-ii both recommended');
        //     // remove sensitive ii
        //     products = products.filter(function(value, index){ 
        //         // return value !== 'cellular-repair-night-cream-sensitive-ii';
        //         // also include refill version
        //         return !(value === 'cellular-repair-night-cream-sensitive-ii' /*|| value === 'cellular-repair-night-cream-sensitive-ii-refill'*/); // ClueEdit : remove -refill from recommendations
        //     });
        // }

        // ClueEdit: new skinquiz 1.107 - not needed anymore
        // // special filter when need ANF II
        // if (addANFII === true && products.indexOf('acne-night-formula-ii') < 0) {
        //     console.log('DEBUG: special condition: Patients under 18 who have used the Acne Night Formula I in the last 3 months should receive Acne Night Formula II, unless they have selected Rosacea or Dermatitis to be their primary concern, add ANF II');
        //     products.push('acne-night-formula-ii');
        //     // also include refill version
        //     // products.push('acne-night-formula-ii-refill'); // ClueEdit : remove -refill from recommendations
        // }


        // special condition
        // The Face Oil, If Dehydrated only - don’t recommend The Face Oil
        console.log('DEBUG: skin type answers', skinTypeAnswers);
        if (skinTypeAnswers && skinTypeAnswers.length === 1 && skinTypeAnswers[0] === 'Dehydrated') {
            console.log('DEBUG: special filter products: when skin type is Dehydrated only, don’t recommend The Face Oil');
            
            if (products.indexOf('face-oil') >= 0) {
                console.log('DEBUG: remove face oil');      
                recommendationsSummary += '   skin type is Dehydrated only, don’t recommend The Face Oil\n';      
                // remove face-oil
                products = products.filter(function(value, index){ 
                    return !(value === 'face-oil' /*|| value === 'face-oil-refill'*/); // ClueEdit : remove -refill from recommendations
                });
            }

        }

        // special conditions for Prescribe For Me products, several products will be consolidated into a single recommendation. which is prescribe for me products: Day Elixir, Night Cream, Spot Treatment, Eye Treatment
        var removeAndReplace = function(prods, rem, rep) {
            // console.log('DEBUG: products 🎉🎉🎉🎉🎉🎉🎉', prods);
            var index = prods.indexOf(rem);
            if (index >= 0) {
                prods.splice(index, 1); // remove the item
                if (prods.indexOf(rep) < 0) {
                    prods.push(rep); // add the new item
                }
            }    
        }

        // ClueEdit: new skinquiz 1.107 - not needed anymore
        // console.log('DEBUG: special condition: Prescribe For Me products, several products will be consolidated into a single recommendation. which is prescribe for me products: Day Elixir, Night Cream, Spot Treatment, Eye Treatment');

        // // Prescribe for Me v1: not relevant anymore
        // // removeAndReplace(products, 'day-brightening-elixir-sensitive', 'day-brightening-elixir-dewy');        
        // // // Acne Night Formula:
        // // // acne-night-formula-ii - acne-night-formula
        // // removeAndReplace(products, 'acne-night-formula-ii', 'acne-night-formula');
        
        // // // Cellular Repair Night Cream:
        // // // cellular-repair-night-cream-sensitive - cellular-repair-night-cream
        // // removeAndReplace(products, 'cellular-repair-night-cream-sensitive', 'cellular-repair-night-cream' );
        // // // cellular-repair-night-cream-sensitive-ii - cellular-repair-night-cream
        // // removeAndReplace(products, 'cellular-repair-night-cream-sensitive-ii', 'cellular-repair-night-cream' );
        // // // total-reset-night-cream - cellular-repair-night-cream
        // // removeAndReplace(products, 'total-reset-night-cream', 'cellular-repair-night-cream' );
        
        // // // Pregnancy Night Cream
        // // // pregnancy-clarifying-night-cream - pregnancy-brightening-night-cream
        // // removeAndReplace(products, 'pregnancy-clarifying-night-cream', 'pregnancy-brightening-night-cream' );

        // // bulk remove and replace
        // var prescribeForMeProducts = {
        //     // Day Elixir
        //     'day-elixir-formula' : [
        //         'day-brightening-elixir-dewy',
        //         'day-brightening-elixir-sensitive'
        //     ],
        //     // Night Cream
        //     'night-cream-formula' : [
        //         'acne-night-formula',
        //         'acne-night-formula-ii',
        //         'cellular-repair-night-cream',
        //         'cellular-repair-night-cream-sensitive',
        //         'cellular-repair-night-cream-sensitive-ii',
        //         'total-reset-night-cream',
        //         'pregnancy-brightening-night-cream',
        //         'pregnancy-clarifying-night-cream',
        //         'pigment-vanishing-night-cream',
        //         'stress-repair-night-cream'
        //     ],
        //     // Spot Treatment
        //     'spot-treatment-formula' : [
        //         'acne-spot-treatment',
        //         'stress-repair-spot-treatment'
        //     ],
        //     // Eye Treatment
        //     'eye-treatment-formula' : [
        //         'brightening-day-eye-serum',
        //         'cellular-repair-night-eye-cream'
        //     ]
        // };
        
        // for (var groupedProduct in prescribeForMeProducts) {
        //     // console.log('DEBUG: groupedProduct', groupedProduct);
        //     prescribeForMeProducts[groupedProduct].forEach(function(productsToRemove){
        //         // console.log('DEBUG: productsToRemove', productsToRemove);
        //             removeAndReplace(products, productsToRemove, groupedProduct);                    
        //     });
        // }

        // ClueEdit: new skinquiz 1.107 - not needed anymore
        // // Special condition where day elixir and night cream are always recommended
        // if (products.indexOf('day-elixir-formula') < 0) {
        //     console.log('DEBUG: special condition: always recommend day elixir');
        //     products.push('day-elixir-formula');
        // }
        // if (products.indexOf('night-cream-formula') < 0) {
        //     console.log('DEBUG: special condition: always recommend night cream');
        //     products.push('night-cream-formula');
        // }

        // ClueEdit: new skinquiz 1.107 - special conditions
        // // Override Night Cream over Day Cream if (Y) for Individual Product for q12 (individual_product_or_set) - Replace day cream with night cream if condition met
        // if (individualOrSetAnswer && individualOrSetAnswer.value === 'Individual product') {
        //     console.log('DEBUG: special condition: Override Night Cream over Day Cream if (Y) for Individual Product for individual_product_or_set');

        //     if (products.indexOf('day-elixir-formula') >= 0) {
        //         // remove
        //         products = products.filter(function(value, index){ 
        //             return !(value === 'day-elixir-formula');
        //         });
        //         // add night-cream-formula, if not exist
        //         if (products.indexOf('night-cream-formula') < 0) {
        //             products.push('night-cream-formula');
        //         }
        //     }
        // }
        // // Override Spot Treatment over Day Cream and Night Cream if (Y) for Individual Product (q12.individual_product_or_set) and Primary Concern is Dermatitis, Acne or Rosacea.
        // if (individualOrSetAnswer && individualOrSetAnswer.value === 'Individual product' && primaryConcernAnswer && ['Dermatitis', 'Acne and/or breakouts', 'Rosacea'].indexOf(primaryConcernAnswer.value) >= 0) {
        //     console.log('DEBUG: special condition: Override Spot Treatment over Day Cream and Night Cream if (Y) for Individual Product and Primary Concern is Dermatitis, Acne or Rosacea');

        //     if (products.indexOf('day-elixir-formula') < 0) {
        //         // remove
        //         products = products.filter(function(value, index){ 
        //             return !(value === 'day-elixir-formula');
        //         });

        //         // add spot-treatment-formula if not exists
        //         if (products.indexOf('spot-treatment-formula') < 0) {
        //             products.push('spot-treatment-formula');
        //         }
        //     }
        // }



        var checkSets = [
            'the-acne-set',
            'the-anti-ageing-set',
            'the-rosacea-set',
            'the-pigment-set',
            'the-hero-set',
            'the-pregnancy-set',
            'the-essential-set',
            'the-signature-set'
        ];
        var checkIndividualProducts = [
            'day-elixir-formula',
            'night-cream-formula',
            'spot-treatment-formula',
            'eye-treatment-formula',
            'enzyme-mask',
            'cleansing-balm',
            'base-cream',
            'oil-cleanser',
            'solar-serum-spf50',
            'face-serum',
            'face-oil',
            'hydrating-duo',
            'skin-saviours',
            'the-full-base-range-bundle',
            'the-prep-protect',
            'the-radiance-bundle'
        ];
        var checkConditionBasedSets = [
            'the-acne-set',
            'the-anti-ageing-set',
            'the-rosacea-set',
            'the-pigment-set'
        ];

        var productContainsSet = false;
        var numberOfSets = 0;
        for (var i = 0; i < products.length; i++) {
            if (checkSets.indexOf(products[i]) !== -1) {
                productContainsSet = true;
                numberOfSets += 1;
                // break;
            }
        }        
        console.log('DEBUG: product contains sets', productContainsSet);
        var productContainsConditionBasedSet = false;
        for (var i = 0; i < products.length; i++) {
            if (checkConditionBasedSets.indexOf(products[i]) !== -1) {
                productContainsConditionBasedSet = true;
                break;
            }
        }
        console.log('DEBUG: product contains condition based sets', productContainsConditionBasedSet);

        // Condition Sets overrides the Essential Set
        if (productContainsConditionBasedSet) {
            if (products.indexOf('the-essential-set') >= 0) {
                console.log('DEBUG: special condition: condition based sets overrides the Essential Set');
                recommendationsSummary += '   condition based sets overrides the Essential Set\n';
                products = products.filter(function(value, index){ 
                    return !(value === 'the-essential-set');
                });
            }
        }

        // 	If (Y) to question 13, the Hero Set will override any recommended sets. Individual products will not be affected.
        if (includeBaseRangeAnswer && includeBaseRangeAnswer.value === 'Yes') {
            console.log('DEBUG: special condition: if they choose (Y) to question 13. include our Base Range, the Hero Set will override any recommended sets');
            if (productContainsSet) {
                recommendationsSummary += '   user choose (Y) to question 13 (include our Base Range), the Hero Set override any recommended sets\n';
                // remove all sets
                products = products.filter(function(value, index){ 
                    return checkSets.indexOf(value) === -1;
                });
                // products = products.filter(function(value, index){ 
                //     return !(value === 'the-acne-set' 
                //             || value === 'the-anti-ageing-set'
                //             || value === 'the-rosacea-set'
                //             || value === 'the-pigment-set'
                //             // || value === 'the-hero-set'
                //             || value === 'the-pregnancy-set'
                //             || value === 'the-essential-set'
                //             || value === 'the-signature-set'
                //         );
                // });
                // add hero set if not exists
                if (products.indexOf('the-hero-set') < 0) {
                    products.push('the-hero-set');
                }
            }
        } else {
            // if not (Y) at question 13, and there are more than 2 sets, and hero set exists, remove hero set
            if (productContainsSet && numberOfSets > 1) {
                console.log('DEBUG: special condition: if not (Y) to question 13, and there are still more than 2 sets, and hero set exists, remove hero set');
                if (products.indexOf('the-hero-set') >= 0) {
                    recommendationsSummary += '   if not (Y) to question 13, and there are still more than 2 sets, and hero set exists, remove hero set\n';
                    // remove hero set
                    products = products.filter(function(value, index){ 
                        return !(value === 'the-hero-set');
                    });
                }
            }
        }

        // // 	Always recommend Solar Serum SPF 50 if they choose (Y) to question 13. include our Base Range
        // if (includeBaseRangeAnswer && includeBaseRangeAnswer.value === 'Yes') {
        //     console.log('DEBUG: special condition: Always recommend Solar Serum SPF 50 if they choose (Y) to question 13. include our Base Range');
        //     if (products.indexOf('solar-serum-spf50') < 0) {
        //         products.push('solar-serum-spf50');
        //     }
        // }
        // Include Signature Set, if more than 1 eye concern is selected (not override) so its possible to have 2 sets here
        if (eyeAreaMainConcernAnswers && eyeAreaMainConcernAnswers.length >= 2) {
            console.log('DEBUG: special condition: Include Signature Set, if more than 1 eye concern is selected (not override)');

            // check if products contains sets product

            // if (productContainsSet) {
                recommendationsSummary += '   more than 1 eye concern is selected, Include Signature Set (not override)\n';
                // // remove all sets
                // products = products.filter(function(value, index){ 
                //     return checkSets.indexOf(value) === -1;
                // });

                // // remove all sets
                // products = products.filter(function(value, index){ 
                //     return !(value === 'the-acne-set' 
                //             || value === 'the-anti-ageing-set'
                //             || value === 'the-rosacea-set'
                //             || value === 'the-pigment-set'
                //             || value === 'the-hero-set'
                //             || value === 'the-pregnancy-set'
                //             || value === 'the-essential-set'
                //             // || value === 'the-signature-set'
                //         );
                // });

                if (products.indexOf('the-signature-set') < 0) {
                    products.push('the-signature-set');
                }
            // }

        }
        // If (Y) to 9,10,11 - Pregnancy Set over rides 
        if ((pregnantAnswer && (pregnantAnswer.value === 'Yes')) || 
            (conceiveAnswer && (conceiveAnswer.value === 'Yes')) || 
            (pregnancySafeAnswer && (pregnancySafeAnswer.value === 'Yes'))) {
            console.log('DEBUG: Special condition: pregnant, conceive and prefer a pregnancy safe option, Pregnancy Set over rides all sets');
            if (productContainsSet) {
                recommendationsSummary += '   (Y) for either pregnant, conceive and prefer a pregnancy safe option, Pregnancy Set over rides all sets\n';
                // remove all sets
                products = products.filter(function(value, index){ 
                    return checkSets.indexOf(value) === -1;
                });
                // add pregnancy set if not exists
                if (products.indexOf('the-pregnancy-set') < 0) {
                    products.push('the-pregnancy-set');
                }
            }
        }    

        // // Override Signature Set if the below eye concerns are selected 
        //     // Puffiness and Wrinkles 
        //     // Puffiness and Pigmentation
        //     // Pigmentation and Fine lines
        //     // Darkness and Pigmentation
        //     // Darkness and wrinkles
        // if (eyeAreaMainConcernAnswers && eyeAreaMainConcernAnswers.length == 2) {
        //     if (products.indexOf('the-signature-set') >= 0) {
        //         if (
        //             (eyeAreaMainConcernAnswers.indexOf('Puffiness') >= 0 && eyeAreaMainConcernAnswers.indexOf('Wrinkles') >= 0)
        //             ||
        //             (eyeAreaMainConcernAnswers.indexOf('Puffiness') >= 0 && eyeAreaMainConcernAnswers.indexOf('Pigmentation') >= 0)
        //             ||
        //             (eyeAreaMainConcernAnswers.indexOf('Pigmentation') >= 0 && eyeAreaMainConcernAnswers.indexOf('Fine lines') >= 0)
        //             ||
        //             (eyeAreaMainConcernAnswers.indexOf('Darkness') >= 0 && eyeAreaMainConcernAnswers.indexOf('Pigmentation') >= 0)
        //             ||
        //             (eyeAreaMainConcernAnswers.indexOf('Darkness') >= 0 && eyeAreaMainConcernAnswers.indexOf('Wrinkles') >= 0)
        //         ) {
        //             // remove the-signature-set
        //             console.log('DEBUG: special condition: Override Signature Set if the below eye concerns are selected: Puffiness and Wrinkles, Puffiness and Pigmentation, Pigmentation and Fine lines, Darkness and Pigmentation, Darkness and wrinkles');
        //             products = products.filter(function(value, index){ 
        //                 return !(value === 'the-signature-set');
        //             });
        //         }

        //     }
        // }
        // individual or sets
        // exclude sets
        if (individualOrSetAnswers && individualOrSetAnswers.length >= 1 && individualOrSetAnswers.indexOf('Skincare Set') < 0)
            {
            console.log('DEBUG: 💲💲💲 special condition: individual or sets doesnt have Skincare sets. exclude skincare sets');
            recommendationsSummary += '   filter: user doesnt choose to include Skincare sets. exclude skincare sets\n';
            // remove all sets
            products = products.filter(function(value, index){ 
                return checkSets.indexOf(value) === -1;
            });
        }
        // exclude individual products
        if (individualOrSetAnswers && individualOrSetAnswers.length >= 1 && individualOrSetAnswers.indexOf('Individual products') < 0) {
            console.log('DEBUG: 💲💲💲 special condition: individual or sets doesnt have Individual products. exclude individual products');
            recommendationsSummary += '   filter: user doesnt choose to include Individual products. exclude individual products\n';

            // remove all individual products
            products = products.filter(function(value, index){ 
                return checkIndividualProducts.indexOf(value) === -1;
            });
        }

        recommendationsSummary += '\nFinalRecommended Products after special conditions (before adding refill version):\n';
        recommendationsSummary += products.join(', ');

        // include refill version
        // in products array, iterate each item, duplicate, and add suffix -refill if not any of these
        let productRefills = [];
        if (products.length) {
            for (let i=0; i<products.length; i++) {
                let prod = products[i];
                if (prod.indexOf(prod + '-refill') < 0) {
                    productRefills.push(prod + '-refill');
                }
            }
        }
        // merge products and productRefills, if productRefills not empty
        if (productRefills.length) {
            products = products.concat(productRefills);
        }


        console.log('DEBUG: products after', products);
        console.log(recommendationsSummary);

        return {
            status: (products.length)?app.RECOMMENDATION_STATUS.FOUND:app.RECOMMENDATION_STATUS.NOTFOUND,
            products: products
        };
    }

    // this get recommendations based on CF form
    // this is auto run
    app.recommendations = function() {
        CF.customerReady(function () {
            console.log('DEBUG: customerReady - recommendations');
            // console.log('DEBUG: TEST VALUE', CF.customer.get('first_name'));

            // calculate recommendations here
            // var products = [
            //     'complimentary-jade-roller',
            //     'mens-day-brightening-elixir',
            //     'body-bundle',
            //     'mens-day-set',
            //     'acne-night-formula'
            //   ];      
            var products = [];
            var status = '';
            
            var dataUrl = app.recommendationsJson;

            if (!dataUrl) {
                console.log('DEBUG: Error. no recommendations json found');
                
                document.dispatchEvent(new CustomEvent('theme:form:recommendations', {
                    'detail': { 'status':'error', 'products': [] }
                }));

                return false;
            }

            fetch(dataUrl).then(function (response) {
                response.json().then(function (result) {
                    console.log('DEBUG: response result', response);
                    var grp;
                  if (response.ok) {
                    console.log('DEBUG: fetch json result', result);

                    grp = getRecommendedProducts(result);
                    products = grp.products;
                    status = grp.status;

                    // possible status: found, not found, error, no data (hasn't take quiz yet)

                    // if found, trigger event 
                    // console.log('DEBUG: recommendations', products);
                    document.dispatchEvent(new CustomEvent('theme:form:recommendations', {
                            'detail': { 'status':status, 'products': products }
                    }));


                  } else {
                      // error
                    document.dispatchEvent(new CustomEvent('theme:form:recommendations', {
                        'detail': { 'status':app.RECOMMENDATION_STATUS.ERROR, 'products': [] }
                    }));    
                  }
                });
              });      

            // setTimeout(function(){
            //     // if found, trigger event 
            //     document.dispatchEvent(new CustomEvent('theme:form:recommendations', {
            //         'detail': { 'status':'found', 'products': products }
            //     }));

            // },3000);
        });
    }

    // global listener for theme:form:recommendations
    (function(){
        var loadingClass = 'template-collection-recommendations--loading';
        var noDataClass = 'template-collection-recommendations--nodata'; // when user hasn't took the quiz

        // add loading class
        document.body.classList.add(loadingClass);

        // listen to theme:form:recommendations
        document.addEventListener('theme:form:recommendations', function(event) {
            var status = event.detail.status; 

            if (status === cdApp.RECOMMENDATION_STATUS.NODATA) {
                console.log('DEBUG: you havent take the quiz');
                document.body.classList.add(noDataClass);
            }
    
            document.body.classList.remove(loadingClass);
        });

  
    }());

    if (app.recommendation) {
        app.recommendations();
    }    

})(window);